export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum ActivityType {
  All = 'all',
  Projects = 'projects',
  Searches = 'searches',
  Unread = 'unread'
}

/** The abstraction of company or contacts */
export type Actor = {
  __typename?: 'Actor';
  activity?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use address instead. */
  adresse?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMoral?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neq?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AddOpportunityTargetCommentInput = {
  comment: Scalars['String']['input'];
  opportunityTargetId: Scalars['Int']['input'];
};

export type AdministrativeBoroughInput = {
  name: Scalars['String']['input'];
};

export type AdministrativeBoroughs = {
  __typename?: 'AdministrativeBoroughs';
  municipalityName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AdministrativeRegion = {
  __typename?: 'AdministrativeRegion';
  name: Scalars['String']['output'];
};

export type AdministrativeRegionInput = {
  name: Scalars['String']['input'];
};

/** Asset type */
export enum AssetType {
  Built = 'built',
  Land = 'land'
}

/** Asset type filter, including records that have no asset type. */
export enum AssetTypeFilter {
  Built = 'built',
  Land = 'land',
  None = 'none'
}

export type AuthResponse = {
  __typename?: 'AuthResponse';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AuthUser>;
};

export type AuthUser = {
  __typename?: 'AuthUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Built category */
export enum BuiltCategory {
  Agricultural = 'agricultural',
  Commercial = 'commercial',
  Industrial = 'industrial',
  Institutional = 'institutional',
  MixedUse = 'mixed_use',
  Multiresidential = 'multiresidential',
  Other = 'other',
  Recreational = 'recreational'
}

/** Built subcategory */
export enum BuiltSubcategory {
  Automotive = 'automotive',
  ColdStorage = 'cold_storage',
  CommercialOffice = 'commercial_office',
  CommercialOther = 'commercial_other',
  DataCenter = 'data_center',
  FlexIndustrial = 'flex_industrial',
  HeavyManufacturing = 'heavy_manufacturing',
  HighRise = 'high_rise',
  HotelMotel = 'hotel_motel',
  IndustrialCondo = 'industrial_condo',
  IndustrialOther = 'industrial_other',
  LightManufacturing = 'light_manufacturing',
  LowRise = 'low_rise',
  MidRise = 'mid_rise',
  MixedUseOther = 'mixed_use_other',
  MultiresidentialOther = 'multiresidential_other',
  Office = 'office',
  Plex_2_6 = 'plex_2_6',
  ResidentialCommercial = 'residential_commercial',
  Retail = 'retail',
  SelfStorage = 'self_storage',
  SeniorsHousing = 'seniors_housing',
  SingleFamilyRental = 'single_family_rental',
  StudentHousing = 'student_housing',
  WarehouseDistribution = 'warehouse_distribution'
}

export type Buyer = {
  __typename?: 'Buyer';
  companyName?: Maybe<Scalars['String']['output']>;
  crmCompanyId?: Maybe<Scalars['String']['output']>;
  crmContactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hubSpotId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['String']['output']>;
  transactions: Array<BuyerTransaction>;
};

export enum BuyerField {
  CompanyName = 'companyName',
  CrmCompanyId = 'crmCompanyId',
  CrmContactId = 'crmContactId',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  RepresentativeId = 'representativeId',
  Transactions = 'transactions'
}

export type BuyerRelatedTransactionViewFilter = {
  __typename?: 'BuyerRelatedTransactionViewFilter';
  assetTypes?: Maybe<Array<AssetType>>;
  boroughs?: Maybe<Array<Scalars['String']['output']>>;
  buildableLandArea?: Maybe<FloatRange>;
  buyerStatus?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  date?: Maybe<DateRange>;
  landArea?: Maybe<FloatRange>;
  landCategories?: Maybe<Array<LandCategory>>;
  landSubcategories?: Maybe<Array<LandSubcategory>>;
  municipalities?: Maybe<Array<Scalars['String']['output']>>;
  price?: Maybe<FloatRange>;
  regions?: Maybe<Array<Scalars['String']['output']>>;
  residentialUnits?: Maybe<FloatRange>;
  source?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<Array<Scalars['String']['output']>>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

export type BuyerRelatedTransactionViewFilterInput = {
  assetTypes?: InputMaybe<Array<AssetTypeFilter>>;
  boroughs?: InputMaybe<Array<Scalars['String']['input']>>;
  buildableLandArea?: InputMaybe<FloatRangeInput>;
  buyerStatus?: InputMaybe<Scalars['String']['input']>;
  composition?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<DateRangeInput>;
  landArea?: InputMaybe<FloatRangeInput>;
  landCategories?: InputMaybe<Array<LandCategory>>;
  landSubcategories?: InputMaybe<Array<LandSubcategory>>;
  municipalities?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<FloatRangeInput>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  residentialUnits?: InputMaybe<FloatRangeInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerTransaction = {
  __typename?: 'BuyerTransaction';
  address?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Array<AssetType>>;
  buildableAreaSqft?: Maybe<Scalars['Float']['output']>;
  deedOfSaleDate?: Maybe<Scalars['Date']['output']>;
  inscriptionNumber: Scalars['String']['output'];
  landCategoryNew?: Maybe<Array<LandCategory>>;
  landSubcategory?: Maybe<Array<LandSubcategory>>;
  numberOfUnits?: Maybe<Scalars['Float']['output']>;
  pricePerBuildableSqft?: Maybe<Scalars['Float']['output']>;
  pricePerLandSqft?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
};

export type BuyerViewFilter = {
  __typename?: 'BuyerViewFilter';
  hasContactDetails?: Maybe<Scalars['Boolean']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<BuyerRelatedTransactionViewFilter>;
};

export type BuyerViewFilterInput = {
  hasContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  transaction?: InputMaybe<BuyerRelatedTransactionViewFilterInput>;
};

export type BuyersList = {
  __typename?: 'BuyersList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CcaContract = {
  __typename?: 'CCAContract';
  contractName?: Maybe<Scalars['String']['output']>;
  hubspotRecordId?: Maybe<Scalars['String']['output']>;
};

export enum CanadianProvince {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ComparableAnalyses = {
  __typename?: 'ComparableAnalyses';
  items: Array<ComparableAnalysisSummary>;
  total: Scalars['Int']['output'];
};

export type ComparableAnalysis = {
  __typename?: 'ComparableAnalysis';
  comparables: Array<ComparableAnalysisComparable>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  missingSubjectParcelIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subject: ComparableAnalysisSubject;
  subjectParcelIds: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ComparableAnalysisComparable = {
  __typename?: 'ComparableAnalysisComparable';
  data?: Maybe<ComparableAnalysisSubject>;
  inscriptionNumber: Scalars['String']['output'];
  /** Current source spelling used to open the transaction; unavailable sources have no source number. */
  sourceInscriptionNumber?: Maybe<Scalars['String']['output']>;
};

export type ComparableAnalysisInput = {
  comparableInscriptionNumbers: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: ComparableAnalysisSubjectInput;
  subjectParcelIds: Array<Scalars['String']['input']>;
};

export type ComparableAnalysisSubject = {
  __typename?: 'ComparableAnalysisSubject';
  address?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  areaSquareFeet?: Maybe<Scalars['Float']['output']>;
  assetType?: Maybe<Array<Scalars['String']['output']>>;
  authorizedUses?: Maybe<Array<Scalars['String']['output']>>;
  broker?: Maybe<Scalars['String']['output']>;
  buildableAreaSqft?: Maybe<Scalars['Float']['output']>;
  buildingAreaSqft?: Maybe<Scalars['Float']['output']>;
  buyerActivity?: Maybe<Scalars['String']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  buyerNeq?: Maybe<Scalars['String']['output']>;
  buyerRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  buyerRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  buyerRepresentatives?: Maybe<Scalars['String']['output']>;
  buyerType?: Maybe<Scalars['String']['output']>;
  codificationType?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contamination?: Maybe<Scalars['String']['output']>;
  contaminationCost?: Maybe<Scalars['Float']['output']>;
  cptaq?: Maybe<Array<Scalars['String']['output']>>;
  currentState?: Maybe<Scalars['String']['output']>;
  dataRoomLink?: Maybe<Scalars['String']['output']>;
  deductionComments?: Maybe<Scalars['String']['output']>;
  deductionFiles?: Maybe<Array<Scalars['String']['output']>>;
  deductionRatio?: Maybe<Scalars['Float']['output']>;
  deedOfSaleDate?: Maybe<Scalars['String']['output']>;
  density?: Maybe<Scalars['Float']['output']>;
  developableLandAreaSqft?: Maybe<Scalars['Float']['output']>;
  endangeredSpecies?: Maybe<Scalars['Boolean']['output']>;
  floodableZone?: Maybe<Scalars['Boolean']['output']>;
  infrastructure?: Maybe<Array<Scalars['String']['output']>>;
  infrastructureDeductionComments?: Maybe<Scalars['String']['output']>;
  infrastructureDeductionRatio?: Maybe<Scalars['Float']['output']>;
  inscriptionNumber?: Maybe<Scalars['String']['output']>;
  isGrossLand?: Maybe<Scalars['Boolean']['output']>;
  landCategoryNew?: Maybe<Array<Scalars['String']['output']>>;
  landShape?: Maybe<Scalars['String']['output']>;
  landSubcategory?: Maybe<Array<Scalars['String']['output']>>;
  landSubtype?: Maybe<Scalars['String']['output']>;
  lender?: Maybe<Scalars['String']['output']>;
  lenderAmount?: Maybe<Scalars['Float']['output']>;
  marketplace?: Maybe<Scalars['String']['output']>;
  marketplaceId?: Maybe<Scalars['String']['output']>;
  mortgage?: Maybe<Scalars['Boolean']['output']>;
  municipalityName?: Maybe<Scalars['String']['output']>;
  netLandAreaSqft?: Maybe<Scalars['Float']['output']>;
  numberOfUnits?: Maybe<Scalars['Int']['output']>;
  padLink?: Maybe<Scalars['String']['output']>;
  parcelIds?: Maybe<Array<Scalars['String']['output']>>;
  parcelReport?: Maybe<Scalars['String']['output']>;
  parkingIndoorCount?: Maybe<Scalars['Int']['output']>;
  parkingOutdoorCount?: Maybe<Scalars['Int']['output']>;
  parkingRatio?: Maybe<Scalars['Float']['output']>;
  parkingTotal?: Maybe<Scalars['Float']['output']>;
  parkingTypes?: Maybe<Array<TransactionParkingType>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pricePerBuildableSqft?: Maybe<Scalars['Float']['output']>;
  pricePerBuildingSqft?: Maybe<Scalars['Float']['output']>;
  pricePerDevelopableSqft?: Maybe<Scalars['Float']['output']>;
  pricePerLandSqft?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  project3dModelLink?: Maybe<Scalars['String']['output']>;
  projectApproval?: Maybe<Scalars['String']['output']>;
  projectApprovalAtDeedOfSale?: Maybe<Scalars['String']['output']>;
  projectComments?: Maybe<Scalars['String']['output']>;
  projectDocument?: Maybe<Scalars['String']['output']>;
  projectLink?: Maybe<Scalars['String']['output']>;
  projectTypes?: Maybe<Array<Scalars['String']['output']>>;
  psaDate?: Maybe<Scalars['String']['output']>;
  saleContext?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  salesBalance?: Maybe<Scalars['Boolean']['output']>;
  sellerActivity?: Maybe<Scalars['String']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
  sellerNeq?: Maybe<Scalars['String']['output']>;
  sellerRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  sellerRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  sellerRepresentatives?: Maybe<Scalars['String']['output']>;
  sellerType?: Maybe<Scalars['String']['output']>;
  siteCoverageRatio?: Maybe<Scalars['Float']['output']>;
  stories?: Maybe<Scalars['Int']['output']>;
  tod?: Maybe<Scalars['Boolean']['output']>;
  unitAreaSqft?: Maybe<Scalars['Float']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  urbanPerimeter?: Maybe<Array<Scalars['String']['output']>>;
  urbanPlanLink?: Maybe<Scalars['String']['output']>;
  wetlands?: Maybe<Scalars['Boolean']['output']>;
  zoningGridLink?: Maybe<Scalars['String']['output']>;
  zoningPlanLink?: Maybe<Scalars['String']['output']>;
};

export type ComparableAnalysisSubjectInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Array<Scalars['String']['input']>>;
  broker?: InputMaybe<Scalars['String']['input']>;
  buildableAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  buyerActivity?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerNeq?: InputMaybe<Scalars['String']['input']>;
  buyerType?: InputMaybe<Scalars['String']['input']>;
  codificationType?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contamination?: InputMaybe<Scalars['String']['input']>;
  contaminationCost?: InputMaybe<Scalars['Float']['input']>;
  cptaq?: InputMaybe<Array<Scalars['String']['input']>>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  deductionComments?: InputMaybe<Scalars['String']['input']>;
  deductionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  deductionRatio?: InputMaybe<Scalars['Float']['input']>;
  deedOfSaleDate?: InputMaybe<Scalars['String']['input']>;
  endangeredSpecies?: InputMaybe<Scalars['Boolean']['input']>;
  floodableZone?: InputMaybe<Scalars['Boolean']['input']>;
  infrastructure?: InputMaybe<Array<Scalars['String']['input']>>;
  infrastructureDeductionComments?: InputMaybe<Scalars['String']['input']>;
  infrastructureDeductionRatio?: InputMaybe<Scalars['Float']['input']>;
  isGrossLand?: InputMaybe<Scalars['Boolean']['input']>;
  landCategoryNew?: InputMaybe<Array<Scalars['String']['input']>>;
  landShape?: InputMaybe<Scalars['String']['input']>;
  landSubcategory?: InputMaybe<Array<Scalars['String']['input']>>;
  landSubtype?: InputMaybe<Scalars['String']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lenderAmount?: InputMaybe<Scalars['Float']['input']>;
  marketplace?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  netLandAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>;
  parcelReport?: InputMaybe<Scalars['String']['input']>;
  parkingIndoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingOutdoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingTypes?: InputMaybe<Array<TransactionParkingType>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  projectApproval?: InputMaybe<Scalars['String']['input']>;
  projectApprovalAtDeedOfSale?: InputMaybe<Scalars['String']['input']>;
  projectComments?: InputMaybe<Scalars['String']['input']>;
  projectDocument?: InputMaybe<Scalars['String']['input']>;
  projectLink?: InputMaybe<Scalars['String']['input']>;
  psaDate?: InputMaybe<Scalars['String']['input']>;
  saleContext?: InputMaybe<Scalars['String']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  salesBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sellerActivity?: InputMaybe<Scalars['String']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerNeq?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
  siteCoverageRatio?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Scalars['Int']['input']>;
  tod?: InputMaybe<Scalars['Boolean']['input']>;
  urbanPerimeter?: InputMaybe<Array<Scalars['String']['input']>>;
  wetlands?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComparableAnalysisSummary = {
  __typename?: 'ComparableAnalysisSummary';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use address instead. */
  adresse?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hubspotId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  primaryCompany?: Maybe<Actor>;
};

export type ContactTransaction = {
  __typename?: 'ContactTransaction';
  administrativeBorough?: Maybe<Scalars['String']['output']>;
  administrativeRegion?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Array<Maybe<AssetType>>>;
  /** @deprecated Use crmCompanyId instead. */
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  crmCompanyId?: Maybe<Scalars['String']['output']>;
  crmContactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use crmContactId instead. */
  hubSpotId?: Maybe<Scalars['String']['output']>;
  inscriptionNumber?: Maybe<Scalars['String']['output']>;
  inscriptionNumbers?: Maybe<Array<Scalars['String']['output']>>;
  landArea?: Maybe<Scalars['Float']['output']>;
  landCategoryNew?: Maybe<Array<Maybe<LandCategory>>>;
  landSubcategory?: Maybe<Array<Maybe<LandSubcategory>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  projectTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  representativeId?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<Transaction>>;
};

export type CreateCustomViewInput = {
  displayConfig?: InputMaybe<Scalars['JSON']['input']>;
  filterConfig?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  opportunityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  sortConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateEmailInput = {
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  customViewId?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  opportunityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
  topic?: InputMaybe<Scalars['String']['input']>;
  userProfileId: Scalars['Int']['input'];
};

export type CreateNotificationInput = {
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  customViewId?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  opportunityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
  topic?: InputMaybe<Scalars['String']['input']>;
  userProfileId: Scalars['Int']['input'];
};

export type CreateSearchContextInput = {
  display?: InputMaybe<SearchContextDisplayInput>;
  layers?: InputMaybe<Array<SearchContextLayerInput>>;
  name: Scalars['String']['input'];
  /** Preset this saved view customizes. At most one per user and preset. Cannot be changed after creation. */
  preset?: InputMaybe<SearchContextPreset>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Only valid for user-owned contexts. Cannot be changed after creation. */
  scope?: InputMaybe<SearchContextScope>;
  /** Null creates a project-owned context and is only valid for non-Workspace projects. */
  userProfileId?: InputMaybe<Scalars['ID']['input']>;
  usesPresetName?: InputMaybe<Scalars['Boolean']['input']>;
  views?: InputMaybe<Array<ViewInput>>;
};

export type CreateTestOpportunitiesInput = {
  assetTypes?: InputMaybe<Array<AssetType>>;
  boroughs?: InputMaybe<Array<Scalars['String']['input']>>;
  buildableSqft?: InputMaybe<FloatRangeInput>;
  count: Scalars['Int']['input'];
  landCategories?: InputMaybe<Array<LandCategory>>;
  landSubcategories?: InputMaybe<Array<LandSubcategory>>;
  municipalities?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityType: OpportunityType;
  parcelIds: Array<Scalars['String']['input']>;
  price?: InputMaybe<FloatRangeInput>;
  priority?: InputMaybe<OpportunityPriority>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  residentialUnits?: InputMaybe<FloatRangeInput>;
  sizeSqft?: InputMaybe<FloatRangeInput>;
  transactionBuyerStatus?: InputMaybe<Scalars['String']['input']>;
  transactionComposition?: InputMaybe<Scalars['String']['input']>;
  transactionSource?: InputMaybe<Scalars['String']['input']>;
  transactionStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionVerificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestOpportunitiesPayload = {
  __typename?: 'CreateTestOpportunitiesPayload';
  createdCount: Scalars['Int']['output'];
  opportunityIds: Array<Scalars['ID']['output']>;
  parcelIds: Array<Scalars['String']['output']>;
};

export type CreateTransactionInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Array<InputMaybe<AssetType>>>;
  /** @deprecated Field no longer supported */
  authorizedUse?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  authorizedUses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  broker?: InputMaybe<Scalars['String']['input']>;
  buildableAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  buyer?: InputMaybe<Scalars['String']['input']>;
  buyerActivity?: InputMaybe<Scalars['String']['input']>;
  buyerNeq?: InputMaybe<Scalars['String']['input']>;
  buyerType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  codificationType?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  componentInscriptionNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  contamination?: InputMaybe<Scalars['String']['input']>;
  contaminationCost?: InputMaybe<Scalars['Float']['input']>;
  cptaq?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  dataRoomLink?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deductionComments?: InputMaybe<Scalars['String']['input']>;
  deductionFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deductionRatio?: InputMaybe<Scalars['Float']['input']>;
  density?: InputMaybe<Scalars['Int']['input']>;
  endangeredSpecies?: InputMaybe<Scalars['Boolean']['input']>;
  floodableZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use isGrossLand instead. */
  grossLand?: InputMaybe<Scalars['Boolean']['input']>;
  infrastructure?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  infrastructureDeductionComments?: InputMaybe<Scalars['String']['input']>;
  infrastructureDeductionRatio?: InputMaybe<Scalars['Float']['input']>;
  inscriptionNumber?: InputMaybe<Scalars['String']['input']>;
  isGrossLand?: InputMaybe<Scalars['Boolean']['input']>;
  landCategory?: InputMaybe<Scalars['String']['input']>;
  landCategoryNew?: InputMaybe<Array<InputMaybe<LandCategory>>>;
  landShape?: InputMaybe<Scalars['String']['input']>;
  landSubcategory?: InputMaybe<Array<InputMaybe<LandSubcategory>>>;
  landSubtype?: InputMaybe<Scalars['String']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lenderAmount?: InputMaybe<Scalars['Float']['input']>;
  marketplace?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  metadataBuildableAreaStatus?: InputMaybe<TransactionFieldStatus>;
  metadataNumberOfUnitsStatus?: InputMaybe<TransactionFieldStatus>;
  metadataStatus?: InputMaybe<Scalars['String']['input']>;
  metadataStoriesStatus?: InputMaybe<TransactionFieldStatus>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  netLandAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  otherZoningDocumentLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  padLink?: InputMaybe<Scalars['String']['input']>;
  parcelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parcelReport?: InputMaybe<Scalars['String']['input']>;
  parkingIndoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingOutdoorCount?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  project3dModelLink?: InputMaybe<Scalars['String']['input']>;
  projectApproval?: InputMaybe<Scalars['String']['input']>;
  projectApprovalAtDeedOfSale?: InputMaybe<Scalars['String']['input']>;
  projectComments?: InputMaybe<Scalars['String']['input']>;
  projectDocument?: InputMaybe<Scalars['String']['input']>;
  projectLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  projectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  psaDate?: InputMaybe<Scalars['String']['input']>;
  saleContext?: InputMaybe<Scalars['String']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  salesBalance?: InputMaybe<Scalars['Boolean']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  sellerActivity?: InputMaybe<Scalars['String']['input']>;
  sellerNeq?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
  siteCoverageRatio?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tod?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  urbanPerimeter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Field no longer supported */
  urbanPlanLink?: InputMaybe<Scalars['String']['input']>;
  wetlands?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  zoningGridLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  zoningPlanLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

export type CreatedServiceToken = {
  __typename?: 'CreatedServiceToken';
  serviceToken: ServiceToken;
  token: Scalars['String']['output'];
};

export type CustomView = {
  __typename?: 'CustomView';
  createdAt: Scalars['Datetime']['output'];
  displayConfig: Scalars['JSON']['output'];
  filterConfig: Scalars['JSON']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  opportunityIds: Array<Scalars['ID']['output']>;
  project?: Maybe<Project>;
  sortConfig: Scalars['JSON']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userProfile: User;
};

export type DateRange = {
  __typename?: 'DateRange';
  max?: Maybe<Scalars['Date']['output']>;
  min?: Maybe<Scalars['Date']['output']>;
};

export type DateRangeInput = {
  max?: InputMaybe<Scalars['Date']['input']>;
  min?: InputMaybe<Scalars['Date']['input']>;
};

export enum DevelopmentPotential {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  None = 'None',
  Unspecified = 'Unspecified'
}

export enum DevelopmentType {
  Agricole = 'AGRICOLE',
  Commercial = 'COMMERCIAL',
  Conservation = 'CONSERVATION',
  Forestier = 'FORESTIER',
  Hotelier = 'HOTELIER',
  Inconnu = 'INCONNU',
  Industriel = 'INDUSTRIEL',
  Institutionnel = 'INSTITUTIONNEL',
  Lotissement = 'LOTISSEMENT',
  Mixte = 'MIXTE',
  Residentiel = 'RESIDENTIEL',
  ResidentielBeton = 'RESIDENTIEL_BETON',
  ResidentielBois = 'RESIDENTIEL_BOIS'
}

export type EmailTemplatePreviewField = {
  __typename?: 'EmailTemplatePreviewField';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  inputType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<EmailTemplatePreviewFieldOption>>;
  required: Scalars['Boolean']['output'];
};

export type EmailTemplatePreviewFieldOption = {
  __typename?: 'EmailTemplatePreviewFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EmailTemplatePreviewTemplate = {
  __typename?: 'EmailTemplatePreviewTemplate';
  description: Scalars['String']['output'];
  fields: Array<EmailTemplatePreviewField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExtendedAccess = {
  __typename?: 'ExtendedAccess';
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt?: Maybe<Scalars['Datetime']['output']>;
  status: ExtendedAccessStatus;
};

export enum ExtendedAccessStatus {
  Active = 'active',
  Available = 'available',
  Expired = 'expired',
  Unavailable = 'unavailable'
}

export type FloatRange = {
  __typename?: 'FloatRange';
  max?: Maybe<Scalars['NonNegativeFloat']['output']>;
  min?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type FloatRangeInput = {
  max?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  min?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

/** A specific point on the globe, float or string? */
export type GeoPoint = {
  __typename?: 'GeoPoint';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
};

/** A polygon is a single shape made of multiple points */
export type GeoPolygon = {
  __typename?: 'GeoPolygon';
  array?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  points?: Maybe<Array<Maybe<GeoPoint>>>;
};

export enum KnownDevelopmentRestriction {
  AdjacentToHighway = 'adjacent_to_highway',
  AdjacentToRailway = 'adjacent_to_railway',
  BuildingToDemolish = 'building_to_demolish',
  Easement = 'easement',
  ExplosionHazard = 'explosion_hazard',
  FloodZone = 'flood_zone',
  HeritageBuilding = 'heritage_building',
  HighVoltageLine = 'high_voltage_line',
  InterimControlRegulation = 'interim_control_regulation',
  Landslide = 'landslide',
  Other = 'other',
  RiparianBuffer = 'riparian_buffer',
  SoilContamination = 'soil_contamination',
  SteepSlopes = 'steep_slopes',
  ThreatenedSpecies = 'threatened_species',
  Wetland = 'wetland'
}

/** Land category */
export enum LandCategory {
  Agricultural = 'agricultural',
  Commercial = 'commercial',
  Conservation = 'conservation',
  Forestry = 'forestry',
  Industrial = 'industrial',
  Institutional = 'institutional',
  Other = 'other',
  Recreational = 'recreational',
  Residential = 'residential'
}

export type LandGptInput = {
  articleRef?: InputMaybe<Scalars['String']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  parcelId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

/** Land subcategory */
export enum LandSubcategory {
  FullForestry = 'full_forestry',
  FullyCultivated = 'fully_cultivated',
  HalfAndHalf = 'half_and_half',
  Heavy = 'heavy',
  HighRise = 'high_rise',
  LightMedium = 'light_medium',
  LowRise = 'low_rise',
  MidRise = 'mid_rise',
  MostlyCultivated = 'mostly_cultivated',
  MostlyForestry = 'mostly_forestry',
  SingleFamily = 'single_family',
  TownHouse = 'town_house'
}

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  borough?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeoPoint>;
  municipality?: Maybe<Scalars['String']['output']>;
};

export enum MainZoning {
  GreenZone = 'green_zone',
  WhiteZoneOutsideUrbanPerimeter = 'white_zone_outside_urban_perimeter',
  WhiteZoneUrbanPerimeter = 'white_zone_urban_perimeter'
}

export enum MapStyle {
  Satellite = 'SATELLITE',
  Simple = 'SIMPLE',
  Standard = 'STANDARD'
}

export enum MarketingType {
  Internal = 'internal',
  Private = 'private',
  Public = 'public'
}

export enum MotivationToSell {
  BusinessAssetsRationalization = 'business_assets_rationalization',
  EndOfBusinessOperations = 'end_of_business_operations',
  EndOfLifePlanning = 'end_of_life_planning',
  EstateSuccession = 'estate_succession',
  FinancialPressure = 'financial_pressure',
  Relocation = 'relocation',
  RequiresFundingForAnotherProject = 'requires_funding_for_another_project',
  Retirement = 'retirement',
  UnableToCreateValue = 'unable_to_create_value',
  ValueMaximization = 'value_maximization'
}

export type MoveOpportunityTargetInput = {
  /** When true then workspace target to CCV pipeline/stage, optional owner fields and we remove opportunity_target row as it is no longer in the scope of a project. Requires fromProjectId which is the workspace, toProjectId is ignored as we don't move it to another project. This is a temporary solution as we still need to refactor the whole mutateOpportunity file. VERY IMPORTANT that we do that */
  convertToCcv?: InputMaybe<Scalars['Boolean']['input']>;
  fromProjectId?: InputMaybe<Scalars['UUID']['input']>;
  hubspotDealId: Scalars['ID']['input'];
  toProjectId?: InputMaybe<Scalars['UUID']['input']>;
};

export type MultiValue = {
  __typename?: 'MultiValue';
  id: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum MunicipalInfrastructure {
  InfrastructureMoratorium = 'infrastructure_moratorium',
  LimitedCapacity = 'limited_capacity',
  NotServed = 'not_served',
  PartiallyServed = 'partially_served',
  Served = 'served',
  Unknown = 'unknown'
}

export enum MunicipalReceptiveness {
  AdvancedDiscussions = 'advanced_discussions',
  ApprovedProject = 'approved_project',
  ConfirmedInWriting = 'confirmed_in_writing',
  ConfirmedVerbally = 'confirmed_verbally',
  InApprovalProcess = 'in_approval_process',
  MidLongTermOnly = 'mid_long_term_only',
  NoInterest = 'no_interest',
  OpenWithChallenges = 'open_with_challenges',
  Probable = 'probable',
  Unknown = 'unknown'
}

export type Municipality = {
  __typename?: 'Municipality';
  name: Scalars['String']['output'];
  regionName?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addContactTransaction?: Maybe<Contact>;
  addOpportunityTargetComment: OpportunityTarget;
  archiveUser: Scalars['Boolean']['output'];
  assignPermissionToRole: UserRole;
  assignUserRoles: Scalars['Boolean']['output'];
  confirmPhoneVerification: PhoneVerificationResult;
  createBuyersList: BuyersList;
  createComparableAnalysis: ComparableAnalysis;
  createCustomView: CustomView;
  createEmail: Scalars['Boolean']['output'];
  createNotification: Notification;
  createOpportunity?: Maybe<Scalars['Float']['output']>;
  createPermission: Permission;
  createSearchContext: SearchContext;
  createServiceToken: CreatedServiceToken;
  createTestOpportunities: CreateTestOpportunitiesPayload;
  createTransaction?: Maybe<Transaction>;
  createUser: User;
  createWorkspace: Project;
  deleteComparableAnalysis: Scalars['Boolean']['output'];
  deleteContactTransaction?: Maybe<Scalars['Boolean']['output']>;
  deleteCustomView: Scalars['Boolean']['output'];
  deleteNotification: Scalars['Boolean']['output'];
  deleteOpportunityTarget?: Maybe<Scalars['Boolean']['output']>;
  deleteSearchContext: Scalars['Boolean']['output'];
  exportParcelReport: ParcelExport;
  inviteContactsToProject?: Maybe<Scalars['Boolean']['output']>;
  loginAsUser: AuthResponse;
  markAllAsRead: Scalars['Int']['output'];
  markNotificationRead?: Maybe<Notification>;
  moveOpportunityTarget?: Maybe<Scalars['Boolean']['output']>;
  recordParcelReportDownload: Scalars['Boolean']['output'];
  revokeServiceToken: Scalars['Boolean']['output'];
  revokeUserToken: Scalars['Boolean']['output'];
  sendSms: Scalars['Boolean']['output'];
  setDefaultPage: User;
  setNotificationPreference: NotificationPreference;
  setPhoneNumber: PhoneNumberResult;
  setPreferredLanguage: User;
  setUnit: User;
  startPhoneVerification: PhoneVerificationStartResult;
  updateComparableAnalysis: ComparableAnalysis;
  updateCurrentUser: User;
  updateCurrentUserPersonalInfo: User;
  updateCustomView: CustomView;
  updateOpportunity: Scalars['Boolean']['output'];
  updateOpportunityEvaluation: OpportunityEvaluation;
  updateProjectSearchContext: SearchContext;
  updateProspectPotential?: Maybe<Scalars['Boolean']['output']>;
  updateSearchContext: SearchContext;
  updateTransaction?: Maybe<Transaction>;
  updateUrbanPriority?: Maybe<Scalars['Boolean']['output']>;
  upsertProject: Project;
  validateIDToken: AuthResponse;
};


export type MutationAddContactTransactionArgs = {
  contactId: Scalars['ID']['input'];
  inscriptionNumber: Scalars['String']['input'];
  primaryCompanyId?: InputMaybe<Scalars['ID']['input']>;
  role: Role;
  source?: InputMaybe<Source>;
};


export type MutationAddOpportunityTargetCommentArgs = {
  input: AddOpportunityTargetCommentInput;
};


export type MutationArchiveUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationAssignPermissionToRoleArgs = {
  permissionIds: Array<Scalars['Int']['input']>;
  roleId: Scalars['Int']['input'];
};


export type MutationAssignUserRolesArgs = {
  roleIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationConfirmPhoneVerificationArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateBuyersListArgs = {
  contactIds: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationCreateComparableAnalysisArgs = {
  input: ComparableAnalysisInput;
};


export type MutationCreateCustomViewArgs = {
  input: CreateCustomViewInput;
};


export type MutationCreateEmailArgs = {
  input: CreateEmailInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOpportunityArgs = {
  input: OpportunityInput;
};


export type MutationCreatePermissionArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateSearchContextArgs = {
  input: CreateSearchContextInput;
};


export type MutationCreateServiceTokenArgs = {
  expiresIn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};


export type MutationCreateTestOpportunitiesArgs = {
  input: CreateTestOpportunitiesInput;
};


export type MutationCreateTransactionArgs = {
  transaction: CreateTransactionInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWorkspaceArgs = {
  userProfileId: Scalars['ID']['input'];
};


export type MutationDeleteComparableAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContactTransactionArgs = {
  contactId: Scalars['ID']['input'];
  inscriptionNumber: Scalars['String']['input'];
};


export type MutationDeleteCustomViewArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOpportunityTargetArgs = {
  hubspotDealId: Scalars['ID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationDeleteSearchContextArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportParcelReportArgs = {
  input: ParcelReportDocumentInput;
};


export type MutationInviteContactsToProjectArgs = {
  invitees: Array<ProjectInviteeInput>;
  projectId: Scalars['UUID']['input'];
};


export type MutationLoginAsUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationMarkAllAsReadArgs = {
  activityType: ActivityType;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMoveOpportunityTargetArgs = {
  input: MoveOpportunityTargetInput;
};


export type MutationRevokeServiceTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeUserTokenArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSendSmsArgs = {
  input: SendSmsInput;
};


export type MutationSetDefaultPageArgs = {
  defaultPage: Page;
};


export type MutationSetNotificationPreferenceArgs = {
  input: SetNotificationPreferenceInput;
};


export type MutationSetPhoneNumberArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetPreferredLanguageArgs = {
  preferredLanguage: Scalars['String']['input'];
};


export type MutationSetUnitArgs = {
  unit: Unit;
};


export type MutationUpdateComparableAnalysisArgs = {
  id: Scalars['ID']['input'];
  input: ComparableAnalysisInput;
  version: Scalars['Int']['input'];
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};


export type MutationUpdateCurrentUserPersonalInfoArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdateCustomViewArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateCustomViewInput;
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateOpportunityEvaluationArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateProjectSearchContextArgs = {
  input: ProjectSearchContextInput;
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateProspectPotentialArgs = {
  parcelID: Scalars['String']['input'];
  potential: DevelopmentPotential;
};


export type MutationUpdateSearchContextArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSearchContextInput;
};


export type MutationUpdateTransactionArgs = {
  overrides: UpdateTransactionInput;
};


export type MutationUpdateUrbanPriorityArgs = {
  parcelId: Scalars['String']['input'];
  priority: UrbanPriorityInput;
};


export type MutationUpsertProjectArgs = {
  input: ProjectInput;
};


export type MutationValidateIdTokenArgs = {
  input: ValidateIdTokenInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  payload: Scalars['JSON']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  title: Scalars['String']['output'];
  topic: NotificationTopic;
  updatedAt: Scalars['Datetime']['output'];
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channel: Scalars['String']['output'];
  consentedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  enabled: Scalars['Boolean']['output'];
  frequency: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  optedOutAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export enum NotificationTopic {
  CommentedOpportunity = 'commented_opportunity',
  DislikedOpportunity = 'disliked_opportunity',
  LikedOpportunity = 'liked_opportunity',
  Other = 'other',
  SavedSearchNewOpportunity = 'saved_search_new_opportunity',
  TargetCreated = 'target_created'
}

export type Opportunity = {
  __typename?: 'Opportunity';
  all_owners_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  all_owners_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  analysis_buildable_area?: Maybe<Scalars['Float']['output']>;
  analysis_buildable_area_price_per_sqft?: Maybe<Scalars['Float']['output']>;
  analysis_land_area?: Maybe<Scalars['Float']['output']>;
  analysis_land_area_price_per_sqft?: Maybe<Scalars['Float']['output']>;
  assetType?: Maybe<Array<Maybe<AssetType>>>;
  broker_email?: Maybe<Scalars['String']['output']>;
  broker_first_name?: Maybe<Scalars['String']['output']>;
  broker_last_name?: Maybe<Scalars['String']['output']>;
  broker_phone_number?: Maybe<Scalars['String']['output']>;
  broker_picture_url?: Maybe<Scalars['String']['output']>;
  call_for_bids?: Maybe<Scalars['Boolean']['output']>;
  canEdit: Scalars['Boolean']['output'];
  collaborative_broker_1_email?: Maybe<Scalars['String']['output']>;
  collaborative_broker_1_name?: Maybe<Scalars['String']['output']>;
  collaborative_broker_1_phone?: Maybe<Scalars['String']['output']>;
  collaborative_broker_1_picture?: Maybe<Scalars['String']['output']>;
  collaborative_broker_2_email?: Maybe<Scalars['String']['output']>;
  collaborative_broker_2_name?: Maybe<Scalars['String']['output']>;
  collaborative_broker_2_phone?: Maybe<Scalars['String']['output']>;
  collaborative_broker_2_picture?: Maybe<Scalars['String']['output']>;
  collaborative_broker_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commentsAboutOwner?: Maybe<Scalars['String']['output']>;
  data_room_cloud_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use assetType, landCategoryNew, and landSubcategory instead */
  development_type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hubspot_record_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  information_on_existing_conditions?: Maybe<Scalars['String']['output']>;
  information_on_potential_and_zoning?: Maybe<Scalars['String']['output']>;
  isPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  isSyncPending?: Maybe<Scalars['Boolean']['output']>;
  knownDevelopmentRestrictions?: Maybe<Array<KnownDevelopmentRestriction>>;
  landCategoryNew?: Maybe<Array<Maybe<LandCategory>>>;
  landSubcategory?: Maybe<Array<Maybe<LandSubcategory>>>;
  lastConversationCity?: Maybe<Scalars['Datetime']['output']>;
  lastConversationOwner?: Maybe<Scalars['Datetime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  launch_date?: Maybe<Scalars['Datetime']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  lot_address?: Maybe<Scalars['String']['output']>;
  lot_borough?: Maybe<Scalars['String']['output']>;
  lot_city?: Maybe<Scalars['String']['output']>;
  lot_image_url?: Maybe<Scalars['String']['output']>;
  lot_numbers?: Maybe<Scalars['String']['output']>;
  lot_numbers_full?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  lot_postal_code?: Maybe<Scalars['String']['output']>;
  lot_region?: Maybe<Scalars['String']['output']>;
  lot_state?: Maybe<Scalars['String']['output']>;
  mainZoning?: Maybe<MainZoning>;
  marketing_type?: Maybe<MarketingType>;
  modelling_link?: Maybe<Scalars['String']['output']>;
  motivationsToSell?: Maybe<Array<MotivationToSell>>;
  municipalInfrastructures?: Maybe<Array<MunicipalInfrastructure>>;
  municipalReceptiveness?: Maybe<Array<MunicipalReceptiveness>>;
  off_market_radius?: Maybe<Scalars['Int']['output']>;
  opportunity_asking_price?: Maybe<Scalars['Float']['output']>;
  opportunity_expiration_date?: Maybe<Scalars['String']['output']>;
  opportunity_type?: Maybe<Scalars['String']['output']>;
  opportunity_webpage_url?: Maybe<Scalars['String']['output']>;
  ownerTypes?: Maybe<Array<OwnerType>>;
  owner_information?: Maybe<Scalars['String']['output']>;
  ownershipDuration?: Maybe<OwnershipDuration>;
  parent_opportunity_type?: Maybe<Scalars['String']['output']>;
  potentialDealStructures?: Maybe<Array<PotentialDealStructure>>;
  priceExpectation?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  pricingSource?: Maybe<PricingSource>;
  primary_seller?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<OpportunityPriority>;
  projectApprovalProcesses?: Maybe<Array<ProjectApprovalProcess>>;
  projectId?: Maybe<Scalars['String']['output']>;
  project_status?: Maybe<Scalars['String']['output']>;
  residentialUnits?: Maybe<Scalars['Int']['output']>;
  sales_process_status?: Maybe<Scalars['String']['output']>;
  stage_label?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OpportunityStatus>;
};

export type OpportunityEvaluation = {
  __typename?: 'OpportunityEvaluation';
  brokerNote?: Maybe<Scalars['String']['output']>;
  clientNote?: Maybe<Scalars['String']['output']>;
  opportunityId: Scalars['ID']['output'];
  priority: OpportunityPriority;
  stage?: Maybe<OpportunityStage>;
  status?: Maybe<OpportunityStatus>;
  updatedAt: Scalars['Datetime']['output'];
};

export enum OpportunityEvaluationFilterStatus {
  Dislike = 'dislike',
  Like = 'like',
  Unset = 'unset'
}

export enum OpportunityField {
  AllOwnersIds = 'all_owners_ids',
  AllOwnersNames = 'all_owners_names',
  AnalysisBuildableArea = 'analysis_buildable_area',
  AnalysisBuildableAreaPricePerSqft = 'analysis_buildable_area_price_per_sqft',
  AnalysisLandArea = 'analysis_land_area',
  AnalysisLandAreaPricePerSqft = 'analysis_land_area_price_per_sqft',
  AssetType = 'assetType',
  BrokerEmail = 'broker_email',
  BrokerFirstName = 'broker_first_name',
  BrokerLastName = 'broker_last_name',
  BrokerPhoneNumber = 'broker_phone_number',
  BrokerPictureUrl = 'broker_picture_url',
  CallForBids = 'call_for_bids',
  CollaborativeBroker_1Email = 'collaborative_broker_1_email',
  CollaborativeBroker_1Name = 'collaborative_broker_1_name',
  CollaborativeBroker_1Phone = 'collaborative_broker_1_phone',
  CollaborativeBroker_1Picture = 'collaborative_broker_1_picture',
  CollaborativeBroker_2Email = 'collaborative_broker_2_email',
  CollaborativeBroker_2Name = 'collaborative_broker_2_name',
  CollaborativeBroker_2Phone = 'collaborative_broker_2_phone',
  CollaborativeBroker_2Picture = 'collaborative_broker_2_picture',
  CollaborativeBrokerNames = 'collaborative_broker_names',
  CommentsAboutOwner = 'commentsAboutOwner',
  DataRoomCloudFile = 'data_room_cloud_file',
  DevelopmentType = 'development_type',
  HubspotRecordId = 'hubspot_record_id',
  Id = 'id',
  InformationOnExistingConditions = 'information_on_existing_conditions',
  InformationOnPotentialAndZoning = 'information_on_potential_and_zoning',
  KnownDevelopmentRestrictions = 'knownDevelopmentRestrictions',
  LandCategoryNew = 'landCategoryNew',
  LandSubcategory = 'landSubcategory',
  LastConversationCity = 'lastConversationCity',
  LastConversationOwner = 'lastConversationOwner',
  Latitude = 'latitude',
  LaunchDate = 'launch_date',
  Longitude = 'longitude',
  LotAddress = 'lot_address',
  LotBorough = 'lot_borough',
  LotCity = 'lot_city',
  LotImageUrl = 'lot_image_url',
  LotNumbers = 'lot_numbers',
  LotNumbersFull = 'lot_numbers_full',
  LotPostalCode = 'lot_postal_code',
  LotRegion = 'lot_region',
  LotState = 'lot_state',
  MainZoning = 'mainZoning',
  MarketingType = 'marketing_type',
  ModellingLink = 'modelling_link',
  MotivationsToSell = 'motivationsToSell',
  MunicipalInfrastructures = 'municipalInfrastructures',
  MunicipalReceptiveness = 'municipalReceptiveness',
  OffMarketRadius = 'off_market_radius',
  OpportunityAskingPrice = 'opportunity_asking_price',
  OpportunityExpirationDate = 'opportunity_expiration_date',
  OpportunityType = 'opportunity_type',
  OpportunityWebpageUrl = 'opportunity_webpage_url',
  OwnerTypes = 'ownerTypes',
  OwnerInformation = 'owner_information',
  OwnershipDuration = 'ownershipDuration',
  ParentOpportunityType = 'parent_opportunity_type',
  PotentialDealStructures = 'potentialDealStructures',
  PriceExpectation = 'priceExpectation',
  PricePerUnit = 'pricePerUnit',
  PricingSource = 'pricingSource',
  PrimarySeller = 'primary_seller',
  Priority = 'priority',
  ProjectApprovalProcesses = 'projectApprovalProcesses',
  ProjectId = 'projectId',
  ProjectStatus = 'project_status',
  ResidentialUnits = 'residentialUnits',
  SalesProcessStatus = 'sales_process_status',
  StageLabel = 'stage_label',
  Status = 'status'
}

export type OpportunityInput = {
  buildableAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  ccaContractHubspotId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dataRoomCloudFile?: InputMaybe<Scalars['String']['input']>;
  developmentType?: InputMaybe<Array<DevelopmentType>>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  informationOnExistingConditions?: InputMaybe<Scalars['String']['input']>;
  informationOnPotentialAndZoning?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['Datetime']['input']>;
  marketingType?: InputMaybe<MarketingType>;
  ownerInformation?: InputMaybe<Scalars['String']['input']>;
  parcelIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  projectId: Scalars['String']['input'];
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  province?: InputMaybe<CanadianProvince>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  totalAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  webpageLink?: InputMaybe<Scalars['String']['input']>;
};

export enum OpportunityPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  Undetermined = 'undetermined'
}

export enum OpportunityStage {
  AnalysisCompleted = 'analysisCompleted',
  AnalysisPresentedAndPsaSubmittedToBuyer = 'analysisPresentedAndPsaSubmittedToBuyer',
  ClosedLost = 'closedLost',
  ClosedWon = 'closedWon',
  ConditionsLifted = 'conditionsLifted',
  DueDiligenceInProgress = 'dueDiligenceInProgress',
  InterestedToSell = 'interestedToSell',
  PsaPresentedToSeller = 'psaPresentedToSeller',
  ReadyForClosing = 'readyForClosing',
  Targets = 'targets',
  TargetsWithContact = 'targetsWithContact'
}

export enum OpportunityStatus {
  Dislike = 'dislike',
  Like = 'like'
}

export type OpportunityTarget = {
  __typename?: 'OpportunityTarget';
  comment?: Maybe<Scalars['String']['output']>;
  hubspotDealId?: Maybe<Scalars['ID']['output']>;
  hubspotParentDealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type OpportunityTargetInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  hubspotDealId?: InputMaybe<Scalars['ID']['input']>;
  hubspotParentDealId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum OpportunityType {
  ListingLanderz = 'listing_landerz',
  ListingPotential = 'listing_potential',
  OffMarketOfficial = 'off_market_official',
  OpportunityTarget = 'opportunity_target'
}

export type OpportunityViewFilter = {
  __typename?: 'OpportunityViewFilter';
  assetTypes: Array<AssetType>;
  boroughs: Array<Scalars['String']['output']>;
  brokers: Array<Scalars['String']['output']>;
  buildableLandArea?: Maybe<FloatRange>;
  collaborativeBrokers: Array<Scalars['String']['output']>;
  developmentTypes: Array<Scalars['String']['output']>;
  evaluationStatus: Array<OpportunityEvaluationFilterStatus>;
  landArea?: Maybe<FloatRange>;
  landCategories: Array<LandCategory>;
  landSubcategories: Array<LandSubcategory>;
  launchDate?: Maybe<DateRange>;
  municipalities: Array<Scalars['String']['output']>;
  opportunityTypes: Array<OpportunityType>;
  price?: Maybe<FloatRange>;
  priority?: Maybe<OpportunityPriority>;
  regions: Array<Scalars['String']['output']>;
  residentialUnits?: Maybe<FloatRange>;
};

export type OpportunityViewFilterInput = {
  assetTypes?: InputMaybe<Array<AssetTypeFilter>>;
  boroughs?: InputMaybe<Array<Scalars['String']['input']>>;
  brokers?: InputMaybe<Array<Scalars['String']['input']>>;
  buildableLandArea?: InputMaybe<FloatRangeInput>;
  collaborativeBrokers?: InputMaybe<Array<Scalars['String']['input']>>;
  developmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  evaluationStatus?: InputMaybe<Array<OpportunityEvaluationFilterStatus>>;
  landArea?: InputMaybe<FloatRangeInput>;
  landCategories?: InputMaybe<Array<LandCategory>>;
  landSubcategories?: InputMaybe<Array<LandSubcategory>>;
  launchDate?: InputMaybe<DateRangeInput>;
  municipalities?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityTypes?: InputMaybe<Array<OpportunityType>>;
  price?: InputMaybe<FloatRangeInput>;
  priority?: InputMaybe<OpportunityPriority>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  residentialUnits?: InputMaybe<FloatRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum OwnerType {
  BankruptcyTrustee = 'bankruptcy_trustee',
  Corporation = 'corporation',
  FamilyTrust = 'family_trust',
  Institutional = 'institutional',
  JudicialSale = 'judicial_sale',
  PrivateOwner = 'private_owner',
  RealEstateDeveloper = 'real_estate_developer',
  RealEstateInvestor = 'real_estate_investor',
  SmallMediumOperatingBusiness = 'small_medium_operating_business',
  Succession = 'succession'
}

export enum OwnershipDuration {
  LessThanThreeYears = 'less_than_three_years',
  OverTenYears = 'over_ten_years',
  ThreeToTenYears = 'three_to_ten_years'
}

export enum Page {
  Activity = 'activity',
  Buyers = 'buyers',
  Exploration = 'exploration',
  Hunting = 'hunting',
  Opportunities = 'opportunities',
  Transactions = 'transactions'
}

export type PaginatedBuyers = {
  __typename?: 'PaginatedBuyers';
  items: Array<Buyer>;
  total: Scalars['Int']['output'];
};

export type PaginatedContactTransactions = {
  __typename?: 'PaginatedContactTransactions';
  items: Array<ContactTransaction>;
  total: Scalars['Int']['output'];
};

export type PaginatedNotifications = {
  __typename?: 'PaginatedNotifications';
  items: Array<Notification>;
  total: Scalars['Int']['output'];
};

export type PaginatedOpportunities = {
  __typename?: 'PaginatedOpportunities';
  items: Array<Opportunity>;
  total: Scalars['Int']['output'];
};

export type PaginatedTransactions = {
  __typename?: 'PaginatedTransactions';
  items: Array<Transaction>;
  total: Scalars['Int']['output'];
};

/** A parcel of land */
export type Parcel = {
  __typename?: 'Parcel';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kml?: Maybe<ParcelExport>;
  location: Location;
  parcelID: Scalars['String']['output'];
  polygon?: Maybe<GeoPolygon>;
  superficy: Superficy;
  zoning: Array<Zone>;
};

export type ParcelExport = {
  __typename?: 'ParcelExport';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum ParcelField {
  IsActive = 'isActive',
  Location = 'location',
  ParcelId = 'parcelID',
  Polygon = 'polygon',
  Superficy = 'superficy'
}

export type ParcelReportAmountInput = {
  label: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ParcelReportChangeInput = {
  detail: Scalars['String']['input'];
  isIncrease: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type ParcelReportCheckInput = {
  detail: Scalars['String']['input'];
  status: ParcelReportConstraintStatus;
  title: Scalars['String']['input'];
};

export type ParcelReportClosingInput = {
  disclaimer: Scalars['String']['input'];
  link: ParcelReportLinkInput;
  qrDescription: Scalars['String']['input'];
};

export type ParcelReportColumnInput = {
  rows: Array<ParcelReportRowInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportConstraintInput = {
  detail: Scalars['String']['input'];
  label: Scalars['String']['input'];
  status: ParcelReportConstraintStatus;
};

export enum ParcelReportConstraintStatus {
  Policy = 'policy',
  Rehabilitated = 'rehabilitated',
  Verified = 'verified',
  Watch = 'watch'
}

export type ParcelReportConstraintStatusLabelsInput = {
  policy: Scalars['String']['input'];
  rehabilitated: Scalars['String']['input'];
  verified: Scalars['String']['input'];
  watch: Scalars['String']['input'];
};

export type ParcelReportCoverInput = {
  address: Scalars['String']['input'];
  constraints: Array<ParcelReportConstraintInput>;
  constraintsSummaryDetail: Scalars['String']['input'];
  keyFigures: Array<ParcelReportKeyFigureInput>;
  locality: Scalars['String']['input'];
  locationMap?: InputMaybe<ParcelReportMapInput>;
  parcelNumber: Scalars['String']['input'];
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

/** Content of the parcel report, already localized and formatted by the client. */
export type ParcelReportDocumentInput = {
  cover: ParcelReportCoverInput;
  labels: ParcelReportLabelsInput;
  parcelID: Scalars['String']['input'];
  sections?: InputMaybe<ParcelReportSectionsInput>;
  unitSystem: Unit;
};

export type ParcelReportEnvironmentSectionInput = {
  checks: Array<ParcelReportCheckInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  measures: Array<ParcelReportMeasureInput>;
  source: Scalars['String']['input'];
  species?: InputMaybe<ParcelReportSpeciesInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportHistoryInput = {
  rows: Array<ParcelReportHistoryRowInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportHistoryRowInput = {
  amount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ParcelReportKeyFigureInput = {
  label: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type ParcelReportLabelsInput = {
  brand: Scalars['String']['input'];
  cadastralLot: Scalars['String']['input'];
  constraintStatuses: ParcelReportConstraintStatusLabelsInput;
  constraintsSummary: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  report: Scalars['String']['input'];
  scaleUnits: ParcelReportScaleUnitsInput;
  source: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type ParcelReportLegendItemInput = {
  /** Hex color, e.g. #3B9C9C. */
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  symbol: ParcelReportLegendSymbol;
};

export enum ParcelReportLegendSymbol {
  Fill = 'fill',
  Outline = 'outline'
}

export type ParcelReportLinkInput = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ParcelReportLotSectionInput = {
  columns: Array<ParcelReportColumnInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  map?: InputMaybe<ParcelReportMapInput>;
  source: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** A map captured by the client; image is a JPEG data URL. */
export type ParcelReportMapInput = {
  attribution: Scalars['String']['input'];
  caption: Scalars['String']['input'];
  image: Scalars['String']['input'];
  legend?: InputMaybe<Array<ParcelReportLegendItemInput>>;
  /** Ground width shown by the image, in meters, used for the scale bar. */
  widthInMeters?: InputMaybe<Scalars['Float']['input']>;
};

export type ParcelReportMeasureInput = {
  detail: Scalars['String']['input'];
  label: Scalars['String']['input'];
  map?: InputMaybe<ParcelReportMapInput>;
  status: ParcelReportConstraintStatus;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ParcelReportNoteInput = {
  link?: InputMaybe<ParcelReportLinkInput>;
  text: Scalars['String']['input'];
};

export type ParcelReportPoliciesInput = {
  items: Array<ParcelReportPolicyInput>;
  map?: InputMaybe<ParcelReportMapInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportPolicyInput = {
  detail: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ParcelReportRowInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ParcelReportScaleUnitsInput = {
  foot: Scalars['String']['input'];
  kilometer: Scalars['String']['input'];
  meter: Scalars['String']['input'];
  mile: Scalars['String']['input'];
};

export type ParcelReportSectionsInput = {
  closing: ParcelReportClosingInput;
  environment: ParcelReportEnvironmentSectionInput;
  lot: ParcelReportLotSectionInput;
  /** Left out when the parcel has no municipal assessment. */
  value?: InputMaybe<ParcelReportValueSectionInput>;
  /** Left out when the parcel has neither zoning data nor planning policy. */
  zoning?: InputMaybe<ParcelReportZoningSectionInput>;
};

export type ParcelReportSpeciesGroupInput = {
  items: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ParcelReportSpeciesInput = {
  groups: Array<ParcelReportSpeciesGroupInput>;
  map?: InputMaybe<ParcelReportMapInput>;
};

export type ParcelReportSplitInput = {
  detail: Scalars['String']['input'];
  parts: Array<ParcelReportSplitPartInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportSplitPartInput = {
  label: Scalars['String']['input'];
  share: Scalars['Float']['input'];
  value: Scalars['String']['input'];
};

export type ParcelReportValueSectionInput = {
  assessment: ParcelReportAmountInput;
  change?: InputMaybe<ParcelReportChangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<ParcelReportHistoryInput>;
  source: Scalars['String']['input'];
  split?: InputMaybe<ParcelReportSplitInput>;
  title: Scalars['String']['input'];
};

export type ParcelReportZoningSectionInput = {
  checks: Array<ParcelReportCheckInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  gridLink?: InputMaybe<ParcelReportLinkInput>;
  map?: InputMaybe<ParcelReportMapInput>;
  norms: Array<ParcelReportColumnInput>;
  normsNote?: InputMaybe<ParcelReportNoteInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<ParcelReportPoliciesInput>;
  source: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ParcelSelection = {
  __typename?: 'ParcelSelection';
  kml?: Maybe<ParcelExport>;
  parcelIDs: Array<Scalars['String']['output']>;
};

export type ParcelViewFilter = {
  __typename?: 'ParcelViewFilter';
  buildingAge?: Maybe<FloatRange>;
  dwellingUnits?: Maybe<FloatRange>;
  ppuArea?: Maybe<Scalars['Boolean']['output']>;
  propertyValue?: Maybe<FloatRange>;
  rainette?: Maybe<Scalars['Boolean']['output']>;
  showStreets?: Maybe<Scalars['Boolean']['output']>;
  soilContaminated?: Maybe<Scalars['Boolean']['output']>;
  storeys?: Maybe<FloatRange>;
  superficy?: Maybe<FloatRange>;
  todArea?: Maybe<Scalars['Boolean']['output']>;
  wetland?: Maybe<Scalars['Boolean']['output']>;
};

export type ParcelViewFilterInput = {
  buildingAge?: InputMaybe<FloatRangeInput>;
  dwellingUnits?: InputMaybe<FloatRangeInput>;
  ppuArea?: InputMaybe<Scalars['Boolean']['input']>;
  propertyValue?: InputMaybe<FloatRangeInput>;
  rainette?: InputMaybe<Scalars['Boolean']['input']>;
  showStreets?: InputMaybe<Scalars['Boolean']['input']>;
  soilContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  storeys?: InputMaybe<FloatRangeInput>;
  superficy?: InputMaybe<FloatRangeInput>;
  todArea?: InputMaybe<Scalars['Boolean']['input']>;
  wetland?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PhoneNumberResult = {
  __typename?: 'PhoneNumberResult';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['String']['output']>;
};

export type PhoneVerificationResult = {
  __typename?: 'PhoneVerificationResult';
  approved: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneVerifiedAt?: Maybe<Scalars['String']['output']>;
};

export type PhoneVerificationStartResult = {
  __typename?: 'PhoneVerificationStartResult';
  phoneNumber: Scalars['String']['output'];
};

export enum PotentialDealStructure {
  BalanceOfSale = 'balance_of_sale',
  ClosingAtMunicipalApproval = 'closing_at_municipal_approval',
  ClosingWhenShovelReady = 'closing_when_shovel_ready',
  ConstructionBySeller = 'construction_by_seller',
  CoveredLandPlay = 'covered_land_play',
  DecontaminationBySeller = 'decontamination_by_seller',
  OtherOptions = 'other_options',
  Partnership = 'partnership',
  QuickSaleRequired = 'quick_sale_required',
  RequiresBusinessOperationsTransition = 'requires_business_operations_transition'
}

export type PreviewEmailTemplateInput = {
  template: Scalars['String']['input'];
  values?: InputMaybe<Scalars['JSON']['input']>;
};

export enum PricingSource {
  LanderzEstimate = 'landerz_estimate',
  OwnerExpectationsFirm = 'owner_expectations_firm',
  OwnerExpectationsNegotiable = 'owner_expectations_negotiable'
}

export type Project = {
  __typename?: 'Project';
  brokerIds: Array<Scalars['Int']['output']>;
  brokers: Array<User>;
  ccaContractHubspotId: Scalars['String']['output'];
  clientIds: Array<Scalars['Int']['output']>;
  clients: Array<Contact>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  expiryDate?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  opportunities: PaginatedOpportunities;
  opportunityTargets: Array<OpportunityTarget>;
  prospectorIds: Array<Scalars['Int']['output']>;
  prospectors: Array<User>;
  /** The shared base restriction for a coordinated project. Always null for Workspaces. */
  searchContext?: Maybe<SearchContext>;
  targetsCount: Scalars['Int']['output'];
  type: ProjectType;
  updatedAt: Scalars['Datetime']['output'];
  viewConfig?: Maybe<Scalars['JSON']['output']>;
};


export type ProjectOpportunitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  view: ViewInput;
};

export enum ProjectApprovalProcess {
  AgriculturalTerritoryExclusion = 'agricultural_territory_exclusion',
  ByRight = 'by_right',
  ConstructionPermitIssued = 'construction_permit_issued',
  DemolitionCommittee = 'demolition_committee',
  InfrastructureExtension = 'infrastructure_extension',
  MinorVariance = 'minor_variance',
  RegulatoryAmendmentCompleted = 'regulatory_amendment_completed',
  SitePlanningAndArchitecturalIntegrationProgram = 'site_planning_and_architectural_integration_program',
  ZoningAmendment = 'zoning_amendment'
}

export type ProjectInput = {
  brokerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ccaContractHubspotId?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  expiryDate?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunityTargets?: InputMaybe<Array<OpportunityTargetInput>>;
  prospectorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  viewConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProjectInviteeInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectSearchContextInput = {
  display?: InputMaybe<SearchContextDisplayInput>;
  layers?: InputMaybe<Array<SearchContextLayerInput>>;
  name: Scalars['String']['input'];
  views?: InputMaybe<Array<ViewInput>>;
};

export enum ProjectStatus {
  ChangementDeZonageAFaire = 'CHANGEMENT_DE_ZONAGE_A_FAIRE',
  ImmeubleADemolir = 'IMMEUBLE_A_DEMOLIR',
  ImmeubleAOperer = 'IMMEUBLE_A_OPERER',
  ImmeubleATransformer = 'IMMEUBLE_A_TRANSFORMER',
  PermisEnCoursDApprobation = 'PERMIS_EN_COURS_D_APPROBATION',
  PretAConstruire = 'PRET_A_CONSTRUIRE',
  TerrainBrut = 'TERRAIN_BRUT',
  TerrainZoneEtDesservi = 'TERRAIN_ZONE_ET_DESSERVI',
  TerrainZoneNonDesservi = 'TERRAIN_ZONE_NON_DESSERVI'
}

export enum ProjectType {
  Cca = 'CCA',
  Ccv = 'CCV',
  Workspace = 'WORKSPACE'
}

export type PropertyUse = {
  __typename?: 'PropertyUse';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 * A parcel of interest, tagged by a user.
 * A prospect is currently a parcel with a potential for development.
 */
export type Prospect = {
  __typename?: 'Prospect';
  potential: DevelopmentPotential;
  prospectID: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  administrativeBoroughs: Array<AdministrativeBoroughs>;
  administrativeRegions: Array<AdministrativeRegion>;
  askLandGpt: Scalars['JSON']['output'];
  buyers: PaginatedBuyers;
  ccaClients: Array<Contact>;
  ccaContracts: Array<CcaContract>;
  comparableAnalyses: ComparableAnalyses;
  comparableAnalysis?: Maybe<ComparableAnalysis>;
  currentUser: User;
  customView?: Maybe<CustomView>;
  customViews: Array<CustomView>;
  emailTemplates: Array<EmailTemplatePreviewTemplate>;
  municipalities: Array<Municipality>;
  notificationPreferences: Array<NotificationPreference>;
  notifications: PaginatedNotifications;
  opportunities: PaginatedOpportunities;
  opportunitiesByIds: Array<Opportunity>;
  opportunity?: Maybe<Opportunity>;
  opportunityEvaluations: Array<OpportunityEvaluation>;
  parcel?: Maybe<Parcel>;
  parcelSelection: ParcelSelection;
  permissions: Array<Permission>;
  previewEmailTemplate: RenderedEmailTemplatePreview;
  project?: Maybe<Project>;
  projects: Array<Project>;
  prospect?: Maybe<Prospect>;
  regions: Array<Region>;
  roles: Array<UserRole>;
  searchCompanies: Array<Company>;
  searchContactTransactions: PaginatedContactTransactions;
  searchContacts: Array<Contact>;
  searchContext?: Maybe<SearchContext>;
  searchContextPresets: Array<SearchContextPresetDefinition>;
  /** Omitting scope lists map saved searches only. */
  searchContexts: Array<SearchContext>;
  searchTransactions: PaginatedTransactions;
  serviceTokens: Array<ServiceToken>;
  transactionByPresentationID?: Maybe<Transaction>;
  transactionsByContactId: Array<Transaction>;
  transactionsByInscriptionNumber?: Maybe<Array<Maybe<Transaction>>>;
  unreadNotificationCount: Scalars['Int']['output'];
  urbanPriority?: Maybe<Array<Maybe<UrbanPriority>>>;
  userHasWorkspace: Scalars['Boolean']['output'];
  users: Array<User>;
  zone?: Maybe<Zone>;
};


export type QueryAskLandGptArgs = {
  input: LandGptInput;
};


export type QueryBuyersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  view?: InputMaybe<ViewInput>;
};


export type QueryCcaClientsArgs = {
  ccaContractHubspotId: Scalars['String']['input'];
};


export type QueryComparableAnalysesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComparableAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomViewArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomViewsArgs = {
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryNotificationsArgs = {
  activityType?: InputMaybe<ActivityType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOpportunitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  view: ViewInput;
};


export type QueryOpportunitiesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryOpportunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpportunityEvaluationsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryParcelArgs = {
  parcelID: Scalars['String']['input'];
};


export type QueryParcelSelectionArgs = {
  parcelIDs: Array<Scalars['String']['input']>;
};


export type QueryPreviewEmailTemplateArgs = {
  input: PreviewEmailTemplateInput;
};


export type QueryProjectArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProjectsArgs = {
  type?: InputMaybe<ProjectType>;
};


export type QueryProspectArgs = {
  parcelID: Scalars['String']['input'];
};


export type QuerySearchCompaniesArgs = {
  partialName: Scalars['String']['input'];
};


export type QuerySearchContactTransactionsArgs = {
  input?: InputMaybe<SearchContactTransactionsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchContactsArgs = {
  contactName: Scalars['String']['input'];
};


export type QuerySearchContextArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchContextPresetsArgs = {
  scope: SearchContextScope;
};


export type QuerySearchContextsArgs = {
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  scope?: InputMaybe<SearchContextScope>;
  userProfileId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchTransactionsArgs = {
  input?: InputMaybe<SearchContactTransactionsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<ViewInput>;
};


export type QueryTransactionByPresentationIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionsByContactIdArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryTransactionsByInscriptionNumberArgs = {
  inscriptionNumber: Scalars['String']['input'];
};


export type QueryUrbanPriorityArgs = {
  parcelId: Scalars['String']['input'];
};


export type QueryUserHasWorkspaceArgs = {
  userProfileId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZoneArgs = {
  zoneCode: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  name: Scalars['String']['output'];
};

export type RenderedEmailTemplatePreview = {
  __typename?: 'RenderedEmailTemplatePreview';
  html: Scalars['String']['output'];
  previewText?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  template: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  Buyer = 'buyer',
  Seller = 'seller'
}

export type SearchContactTransactionsInput = {
  administrativeBoroughs?: InputMaybe<Array<AdministrativeBoroughInput>>;
  administrativeRegions?: InputMaybe<Array<AdministrativeRegionInput>>;
  assetType?: InputMaybe<Array<InputMaybe<AssetType>>>;
  buildableLandAreaRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  buyerStatus?: InputMaybe<Scalars['String']['input']>;
  composition?: InputMaybe<Scalars['String']['input']>;
  hasContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  landAreaRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  landCategoryNew?: InputMaybe<Array<InputMaybe<LandCategory>>>;
  landSubcategory?: InputMaybe<Array<InputMaybe<LandSubcategory>>>;
  municipalities?: InputMaybe<Array<Scalars['String']['input']>>;
  priceRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  projectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  residentialUnitsRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionDateRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SearchContext = {
  __typename?: 'SearchContext';
  createdAt: Scalars['Datetime']['output'];
  display: SearchContextDisplay;
  id: Scalars['ID']['output'];
  layers: Array<SearchContextLayer>;
  name: Scalars['String']['output'];
  /** Read-only preset this saved view customizes. Clients hide the preset for its owner while this copy exists. */
  preset?: Maybe<SearchContextPreset>;
  project?: Maybe<Project>;
  /** Null for map saved searches and project search contexts. */
  scope?: Maybe<SearchContextScope>;
  updatedAt: Scalars['Datetime']['output'];
  userProfile?: Maybe<User>;
  /** Clients display the translated preset name instead of name until the copy is renamed. */
  usesPresetName: Scalars['Boolean']['output'];
  views: Array<View>;
};

export type SearchContextDisplay = {
  __typename?: 'SearchContextDisplay';
  mapStyle?: Maybe<MapStyle>;
};

export type SearchContextDisplayInput = {
  mapStyle?: InputMaybe<MapStyle>;
};

export type SearchContextLayer = {
  __typename?: 'SearchContextLayer';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sublayers: Array<SearchContextLayer>;
};

export type SearchContextLayerInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sublayers?: InputMaybe<Array<SearchContextLayerInput>>;
};

export enum SearchContextPreset {
  Industrial = 'INDUSTRIAL',
  Multiresidential = 'MULTIRESIDENTIAL'
}

/** Read-only saved view offered to every user of a table. Clients translate its name from preset. */
export type SearchContextPresetDefinition = {
  __typename?: 'SearchContextPresetDefinition';
  preset: SearchContextPreset;
  views: Array<View>;
};

export enum SearchContextScope {
  OpportunitiesHuntingTable = 'OPPORTUNITIES_HUNTING_TABLE',
  OpportunitiesTable = 'OPPORTUNITIES_TABLE',
  TransactionsTable = 'TRANSACTIONS_TABLE'
}

export type SendSmsInput = {
  message: Scalars['String']['input'];
  userProfileId: Scalars['Int']['input'];
};

export type ServiceToken = {
  __typename?: 'ServiceToken';
  createdBy: Scalars['ID']['output'];
  createdByUser: ServiceTokenActor;
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['String']['output']>;
  revokedByUser?: Maybe<ServiceTokenActor>;
};

export type ServiceTokenActor = {
  __typename?: 'ServiceTokenActor';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SetNotificationPreferenceInput = {
  channel: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  frequency?: InputMaybe<Scalars['String']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Source {
  App = 'app',
  Manual = 'manual'
}

/** The measurement (area) of a property or land */
export type Superficy = {
  __typename?: 'Superficy';
  squareFeet?: Maybe<Scalars['Float']['output']>;
  squareMeters?: Maybe<Scalars['Float']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  address?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  adjustedPrice?: Maybe<Scalars['Float']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  areaSquareFeet?: Maybe<Scalars['Float']['output']>;
  assetType?: Maybe<Array<Maybe<AssetType>>>;
  authorizedUse?: Maybe<Scalars['String']['output']>;
  authorizedUses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  broker?: Maybe<Scalars['String']['output']>;
  buildableAreaSqft?: Maybe<Scalars['Float']['output']>;
  /** Building floor area from the assessment roll, in square feet; unavailable values are null. */
  buildingAreaSqft?: Maybe<Scalars['Float']['output']>;
  builtCategories?: Maybe<Array<BuiltCategory>>;
  builtSubcategories?: Maybe<Array<BuiltSubcategory>>;
  /** todo: have a list of Actors */
  buyer?: Maybe<Actor>;
  buyerRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  buyerRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityInformationSheetUrl?: Maybe<Scalars['String']['output']>;
  classificationComments?: Maybe<Scalars['String']['output']>;
  codificationType?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  components?: Maybe<Array<Transaction>>;
  constructabilityComments?: Maybe<Scalars['String']['output']>;
  constructionYearMax?: Maybe<Scalars['Int']['output']>;
  constructionYearMin?: Maybe<Scalars['Int']['output']>;
  /** todo: have a list of Actors */
  contacts?: Maybe<Array<Maybe<Contact>>>;
  contamination?: Maybe<Scalars['String']['output']>;
  contaminationCost?: Maybe<Scalars['Float']['output']>;
  cptaq?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentState?: Maybe<Scalars['String']['output']>;
  dataRoomLink?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Datetime']['output']>;
  deductionComments?: Maybe<Scalars['String']['output']>;
  deductionFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deductionRatio?: Maybe<Scalars['Float']['output']>;
  deedOfSaleDate?: Maybe<Scalars['Datetime']['output']>;
  deedOfSaleUrl?: Maybe<Scalars['String']['output']>;
  density?: Maybe<Scalars['Float']['output']>;
  developableLandAreaSqft?: Maybe<Scalars['Float']['output']>;
  driveFileCount?: Maybe<Scalars['Int']['output']>;
  driveFolderId?: Maybe<Scalars['String']['output']>;
  endangeredSpecies?: Maybe<Scalars['Boolean']['output']>;
  floodableZone?: Maybe<Scalars['Boolean']['output']>;
  /** Gross annual rental income in dollars, as supplied by the RF pipeline. */
  grossAnnualRent?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use isGrossLand instead. */
  grossLand?: Maybe<Scalars['Boolean']['output']>;
  /** Gross monthly rental income per assessment-roll dwelling, in dollars; null for buildings with non-residential units. */
  grossMonthlyRentPerUnit?: Maybe<Scalars['Float']['output']>;
  /** Pipeline sale price divided by gross annual rental income; unitless and null when annual rent is not positive. */
  grossRentMultiplier?: Maybe<Scalars['Float']['output']>;
  hasIndoorParking?: Maybe<Scalars['Boolean']['output']>;
  hasLegacy?: Maybe<Scalars['Boolean']['output']>;
  hasOutdoorParking?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  infrastructure?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  infrastructureDeductionComments?: Maybe<Scalars['String']['output']>;
  infrastructureDeductionRatio?: Maybe<Scalars['Float']['output']>;
  inscriptionNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  interactiveMapUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  isDevelopment?: Maybe<Scalars['Boolean']['output']>;
  isGrossLand?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use landCategoryNew and landSubcategory instead */
  landCategory?: Maybe<Scalars['String']['output']>;
  landCategoryNew?: Maybe<Array<Maybe<LandCategory>>>;
  landShape?: Maybe<Scalars['String']['output']>;
  landSubcategory?: Maybe<Array<Maybe<LandSubcategory>>>;
  /** @deprecated Use landCategoryNew and landSubcategory instead */
  landSubtype?: Maybe<Scalars['String']['output']>;
  lender?: Maybe<Scalars['String']['output']>;
  lenderAmount?: Maybe<Scalars['Float']['output']>;
  location: Location;
  marketplace?: Maybe<Scalars['String']['output']>;
  marketplaceId?: Maybe<Scalars['String']['output']>;
  metadataBuildableAreaStatus?: Maybe<TransactionFieldStatus>;
  metadataBuyerDoneAt?: Maybe<Scalars['Date']['output']>;
  metadataBuyerStatus?: Maybe<Scalars['String']['output']>;
  metadataDoneAt?: Maybe<Scalars['Date']['output']>;
  metadataNumberOfUnitsStatus?: Maybe<TransactionFieldStatus>;
  metadataStatus?: Maybe<Scalars['String']['output']>;
  metadataStoriesStatus?: Maybe<TransactionFieldStatus>;
  mortgage?: Maybe<Scalars['Boolean']['output']>;
  netLandAreaSqft?: Maybe<Scalars['Float']['output']>;
  numberOfUnits?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  otherZoningDocumentLink?: Maybe<Scalars['String']['output']>;
  ownershipPercentage?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Field no longer supported */
  padLink?: Maybe<Scalars['String']['output']>;
  parcelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parcelReport?: Maybe<Scalars['String']['output']>;
  parcels?: Maybe<Array<Maybe<Parcel>>>;
  parkingIndoorCount?: Maybe<Scalars['Int']['output']>;
  parkingOutdoorCount?: Maybe<Scalars['Int']['output']>;
  parkingRatio?: Maybe<Scalars['Float']['output']>;
  parkingTotal?: Maybe<Scalars['Int']['output']>;
  parkingTypes?: Maybe<Array<TransactionParkingType>>;
  planMapUrl?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  presentationID?: Maybe<Scalars['ID']['output']>;
  pricePerBuildableSqft?: Maybe<Scalars['Float']['output']>;
  /** Whole transaction sale price per square foot of building floor area from the assessment roll. */
  pricePerBuildingSqft?: Maybe<Scalars['Float']['output']>;
  pricePerDevelopableSqft?: Maybe<Scalars['Float']['output']>;
  pricePerLandSqft?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  project3dModelLink?: Maybe<Scalars['String']['output']>;
  projectApproval?: Maybe<Scalars['String']['output']>;
  projectApprovalAtDeedOfSale?: Maybe<Scalars['String']['output']>;
  projectComments?: Maybe<Scalars['String']['output']>;
  projectDocument?: Maybe<Scalars['String']['output']>;
  projectLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use landCategoryNew and landSubcategory instead */
  projectTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  propertyUses?: Maybe<Array<PropertyUse>>;
  psaDate?: Maybe<Scalars['Datetime']['output']>;
  saleContext?: Maybe<Scalars['String']['output']>;
  /** Use TransactionType instead if of String */
  salePrice?: Maybe<Scalars['Float']['output']>;
  salesBalance: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  sateliteMapUrl?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Actor>;
  sellerRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  sellerRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  siteCoverageRatio?: Maybe<Scalars['Float']['output']>;
  stories?: Maybe<Scalars['Int']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  superficy?: Maybe<Superficy>;
  tod?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use assetType instead */
  type?: Maybe<Scalars['String']['output']>;
  unitAreaSqft?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Field no longer supported */
  unitType?: Maybe<Scalars['String']['output']>;
  urbanPerimeter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Field no longer supported */
  urbanPlanLink?: Maybe<Scalars['String']['output']>;
  volumetricImageUrl?: Maybe<Scalars['String']['output']>;
  wetlands?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  zoningGridLink?: Maybe<Scalars['String']['output']>;
  zoningImageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  zoningPlanLink?: Maybe<Scalars['String']['output']>;
  zoningReportUrl?: Maybe<Scalars['String']['output']>;
};

export enum TransactionField {
  Address = 'address',
  AdjustedPrice = 'adjustedPrice',
  Agency = 'agency',
  AreaSquareFeet = 'areaSquareFeet',
  AssetType = 'assetType',
  AuthorizedUse = 'authorizedUse',
  AuthorizedUses = 'authorizedUses',
  Broker = 'broker',
  BuildableAreaSqft = 'buildableAreaSqft',
  BuildingAreaSqft = 'buildingAreaSqft',
  BuiltCategories = 'builtCategories',
  BuiltSubcategories = 'builtSubcategories',
  Buyer = 'buyer',
  BuyerRepresentativeFirstName = 'buyerRepresentativeFirstName',
  BuyerRepresentativeLastName = 'buyerRepresentativeLastName',
  City = 'city',
  CodificationType = 'codificationType',
  Comments = 'comments',
  ConstructionYearMax = 'constructionYearMax',
  ConstructionYearMin = 'constructionYearMin',
  Contacts = 'contacts',
  Contamination = 'contamination',
  Cptaq = 'cptaq',
  CurrentState = 'currentState',
  DataRoomLink = 'dataRoomLink',
  Date = 'date',
  DeedOfSaleDate = 'deedOfSaleDate',
  DeedOfSaleUrl = 'deedOfSaleUrl',
  Density = 'density',
  GrossAnnualRent = 'grossAnnualRent',
  GrossLand = 'grossLand',
  GrossMonthlyRentPerUnit = 'grossMonthlyRentPerUnit',
  GrossRentMultiplier = 'grossRentMultiplier',
  HasIndoorParking = 'hasIndoorParking',
  HasLegacy = 'hasLegacy',
  HasOutdoorParking = 'hasOutdoorParking',
  Id = 'id',
  Infrastructure = 'infrastructure',
  InfrastructureDeductionComments = 'infrastructureDeductionComments',
  InscriptionNumber = 'inscriptionNumber',
  IsGrossLand = 'isGrossLand',
  LandCategory = 'landCategory',
  LandCategoryNew = 'landCategoryNew',
  LandShape = 'landShape',
  LandSubcategory = 'landSubcategory',
  LandSubtype = 'landSubtype',
  Lender = 'lender',
  LenderAmount = 'lenderAmount',
  Location = 'location',
  Marketplace = 'marketplace',
  MarketplaceId = 'marketplaceId',
  MetadataBuildableAreaStatus = 'metadataBuildableAreaStatus',
  MetadataBuyerStatus = 'metadataBuyerStatus',
  MetadataNumberOfUnitsStatus = 'metadataNumberOfUnitsStatus',
  MetadataStatus = 'metadataStatus',
  MetadataStoriesStatus = 'metadataStoriesStatus',
  Mortgage = 'mortgage',
  NetLandAreaSqft = 'netLandAreaSqft',
  NumberOfUnits = 'numberOfUnits',
  OtherZoningDocumentLink = 'otherZoningDocumentLink',
  PadLink = 'padLink',
  ParcelIds = 'parcelIds',
  ParcelReport = 'parcelReport',
  Parcels = 'parcels',
  ParkingIndoorCount = 'parkingIndoorCount',
  ParkingOutdoorCount = 'parkingOutdoorCount',
  ParkingRatio = 'parkingRatio',
  ParkingTotal = 'parkingTotal',
  ParkingTypes = 'parkingTypes',
  PostalCode = 'postalCode',
  PresentationId = 'presentationID',
  PricePerBuildableSqft = 'pricePerBuildableSqft',
  PricePerBuildingSqft = 'pricePerBuildingSqft',
  PricePerDevelopableSqft = 'pricePerDevelopableSqft',
  PricePerLandSqft = 'pricePerLandSqft',
  PricePerUnit = 'pricePerUnit',
  Project3dModelLink = 'project3dModelLink',
  ProjectApproval = 'projectApproval',
  ProjectApprovalAtDeedOfSale = 'projectApprovalAtDeedOfSale',
  ProjectComments = 'projectComments',
  ProjectDocument = 'projectDocument',
  ProjectLink = 'projectLink',
  ProjectTypes = 'projectTypes',
  PropertyUses = 'propertyUses',
  PsaDate = 'psaDate',
  SaleContext = 'saleContext',
  SalePrice = 'salePrice',
  SalesBalance = 'salesBalance',
  Seller = 'seller',
  SellerRepresentativeFirstName = 'sellerRepresentativeFirstName',
  SellerRepresentativeLastName = 'sellerRepresentativeLastName',
  SiteCoverageRatio = 'siteCoverageRatio',
  Stories = 'stories',
  Subcategory = 'subcategory',
  Superficy = 'superficy',
  Tod = 'tod',
  Type = 'type',
  UnitAreaSqft = 'unitAreaSqft',
  UnitType = 'unitType',
  UrbanPerimeter = 'urbanPerimeter',
  UrbanPlanLink = 'urbanPlanLink',
  ZoningGridLink = 'zoningGridLink',
  ZoningPlanLink = 'zoningPlanLink'
}

export enum TransactionFieldStatus {
  NotApplicable = 'not_applicable',
  Surveyed = 'surveyed',
  Unavailable = 'unavailable',
  Upcoming = 'upcoming'
}

/** @deprecated(reason: "Use UpdateTransactionInput instead.") */
export type TransactionOverrides = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  authorizedUse?: InputMaybe<Scalars['String']['input']>;
  authorizedUses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  broker?: InputMaybe<Scalars['String']['input']>;
  buildableAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  buyer?: InputMaybe<Scalars['String']['input']>;
  buyerActivity?: InputMaybe<Scalars['String']['input']>;
  buyerNeq?: InputMaybe<Scalars['String']['input']>;
  buyerType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  codificationType?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contamination?: InputMaybe<Scalars['String']['input']>;
  contaminationCost?: InputMaybe<Scalars['Float']['input']>;
  cptaq?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  dataRoomLink?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deductionComments?: InputMaybe<Scalars['String']['input']>;
  deductionFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deductionRatio?: InputMaybe<Scalars['Float']['input']>;
  density?: InputMaybe<Scalars['Int']['input']>;
  endangeredSpecies?: InputMaybe<Scalars['Boolean']['input']>;
  floodableZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use isGrossLand instead. */
  grossLand?: InputMaybe<Scalars['Boolean']['input']>;
  infrastructure?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  infrastructureDeductionComments?: InputMaybe<Scalars['String']['input']>;
  infrastructureDeductionRatio?: InputMaybe<Scalars['Float']['input']>;
  inscriptionNumber: Scalars['String']['input'];
  isGrossLand?: InputMaybe<Scalars['Boolean']['input']>;
  landCategory?: InputMaybe<Scalars['String']['input']>;
  landShape?: InputMaybe<Scalars['String']['input']>;
  landSubtype?: InputMaybe<Scalars['String']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lenderAmount?: InputMaybe<Scalars['Float']['input']>;
  marketplace?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  metadataBuildableAreaStatus?: InputMaybe<TransactionFieldStatus>;
  metadataNumberOfUnitsStatus?: InputMaybe<TransactionFieldStatus>;
  metadataStatus?: InputMaybe<Scalars['String']['input']>;
  metadataStoriesStatus?: InputMaybe<TransactionFieldStatus>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  netLandAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>;
  otherZoningDocumentLink?: InputMaybe<Scalars['String']['input']>;
  padLink?: InputMaybe<Scalars['String']['input']>;
  parcelReport?: InputMaybe<Scalars['String']['input']>;
  parcels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingIndoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingOutdoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingTypes?: InputMaybe<Array<TransactionParkingType>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  presentationId?: InputMaybe<Scalars['Int']['input']>;
  project3dModelLink?: InputMaybe<Scalars['String']['input']>;
  projectApproval?: InputMaybe<Scalars['String']['input']>;
  projectApprovalAtDeedOfSale?: InputMaybe<Scalars['String']['input']>;
  projectComments?: InputMaybe<Scalars['String']['input']>;
  projectDocument?: InputMaybe<Scalars['String']['input']>;
  projectLink?: InputMaybe<Scalars['String']['input']>;
  projectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  psaDate?: InputMaybe<Scalars['String']['input']>;
  saleContext?: InputMaybe<Scalars['String']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  salesBalance?: InputMaybe<Scalars['Boolean']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  sellerActivity?: InputMaybe<Scalars['String']['input']>;
  sellerNeq?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
  siteCoverageRatio?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tod?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  urbanPerimeter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urbanPlanLink?: InputMaybe<Scalars['String']['input']>;
  wetlands?: InputMaybe<Scalars['Boolean']['input']>;
  zoningGridLink?: InputMaybe<Scalars['String']['input']>;
  zoningPlanLink?: InputMaybe<Scalars['String']['input']>;
};

export enum TransactionParkingType {
  Indoor = 'indoor',
  None = 'none',
  Outdoor = 'outdoor',
  Unknown = 'unknown'
}

export type TransactionViewFilter = {
  __typename?: 'TransactionViewFilter';
  assetTypes: Array<AssetType>;
  boroughs: Array<Scalars['String']['output']>;
  buildableLandArea?: Maybe<FloatRange>;
  buildingAge?: Maybe<FloatRange>;
  buildingArea?: Maybe<FloatRange>;
  builtCategories: Array<BuiltCategory>;
  builtSubcategories: Array<BuiltSubcategory>;
  buyerStatus?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  date?: Maybe<DateRange>;
  grossAnnualRent?: Maybe<FloatRange>;
  grossMonthlyRentPerUnit?: Maybe<FloatRange>;
  grossRentMultiplier?: Maybe<FloatRange>;
  landArea?: Maybe<FloatRange>;
  landCategories: Array<LandCategory>;
  landSubcategories: Array<LandSubcategory>;
  municipalities: Array<Scalars['String']['output']>;
  /** Matches any selected parking type, including inferred presence. Empty means all transactions. */
  parkingTypes: Array<TransactionParkingType>;
  price?: Maybe<FloatRange>;
  /** Inclusive price range in dollars per square foot of building floor area; active bounds exclude unavailable values. */
  pricePerBuildingSqft?: Maybe<FloatRange>;
  pricePerUnit?: Maybe<FloatRange>;
  propertyUses: Array<Scalars['String']['output']>;
  regions: Array<Scalars['String']['output']>;
  residentialUnits?: Maybe<FloatRange>;
  search?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

export type TransactionViewFilterInput = {
  assetTypes?: InputMaybe<Array<AssetTypeFilter>>;
  boroughs?: InputMaybe<Array<Scalars['String']['input']>>;
  buildableLandArea?: InputMaybe<FloatRangeInput>;
  buildingAge?: InputMaybe<FloatRangeInput>;
  buildingArea?: InputMaybe<FloatRangeInput>;
  builtCategories?: InputMaybe<Array<BuiltCategory>>;
  builtSubcategories?: InputMaybe<Array<BuiltSubcategory>>;
  buyerStatus?: InputMaybe<Scalars['String']['input']>;
  composition?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<DateRangeInput>;
  grossAnnualRent?: InputMaybe<FloatRangeInput>;
  grossMonthlyRentPerUnit?: InputMaybe<FloatRangeInput>;
  grossRentMultiplier?: InputMaybe<FloatRangeInput>;
  landArea?: InputMaybe<FloatRangeInput>;
  landCategories?: InputMaybe<Array<LandCategory>>;
  landSubcategories?: InputMaybe<Array<LandSubcategory>>;
  municipalities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any selected parking type, including inferred presence. Empty means all transactions. */
  parkingTypes?: InputMaybe<Array<TransactionParkingType>>;
  price?: InputMaybe<FloatRangeInput>;
  /** Inclusive price range in dollars per square foot of building floor area; omitted bounds impose no restriction. */
  pricePerBuildingSqft?: InputMaybe<FloatRangeInput>;
  pricePerUnit?: InputMaybe<FloatRangeInput>;
  propertyUses?: InputMaybe<Array<Scalars['String']['input']>>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  residentialUnits?: InputMaybe<FloatRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export enum Unit {
  Imperial = 'imperial',
  Metric = 'metric'
}

export type UpdateCurrentUserInput = {
  extendedAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomViewInput = {
  displayConfig?: InputMaybe<Scalars['JSON']['input']>;
  filterConfig?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOpportunityInput = {
  assetType?: InputMaybe<Array<AssetType>>;
  brokerNote?: InputMaybe<Scalars['String']['input']>;
  buildableArea?: InputMaybe<Scalars['Float']['input']>;
  callback?: InputMaybe<Scalars['Boolean']['input']>;
  clientNote?: InputMaybe<Scalars['String']['input']>;
  commentsAboutOwner?: InputMaybe<Scalars['String']['input']>;
  crmEventOccurredAt?: InputMaybe<Scalars['Datetime']['input']>;
  existingConditionsComments?: InputMaybe<Scalars['String']['input']>;
  knownDevelopmentRestrictions?: InputMaybe<Array<KnownDevelopmentRestriction>>;
  landCategoryNew?: InputMaybe<Array<LandCategory>>;
  landSubcategory?: InputMaybe<Array<LandSubcategory>>;
  lastConversationCity?: InputMaybe<Scalars['Date']['input']>;
  mainZoning?: InputMaybe<MainZoning>;
  modellingLink?: InputMaybe<Scalars['String']['input']>;
  motivationsToSell?: InputMaybe<Array<MotivationToSell>>;
  municipalInfrastructures?: InputMaybe<Array<MunicipalInfrastructure>>;
  municipalReceptiveness?: InputMaybe<Array<MunicipalReceptiveness>>;
  opportunityId: Scalars['ID']['input'];
  ownerTypes?: InputMaybe<Array<OwnerType>>;
  ownershipDuration?: InputMaybe<OwnershipDuration>;
  potentialDealStructures?: InputMaybe<Array<PotentialDealStructure>>;
  potentialProjectComments?: InputMaybe<Scalars['String']['input']>;
  pricingSource?: InputMaybe<PricingSource>;
  priority?: InputMaybe<OpportunityPriority>;
  projectApprovalProcesses?: InputMaybe<Array<ProjectApprovalProcess>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  residentialUnits?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpportunityStatus>;
};

export type UpdateSearchContextInput = {
  display?: InputMaybe<SearchContextDisplayInput>;
  layers?: InputMaybe<Array<SearchContextLayerInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  views?: InputMaybe<Array<ViewInput>>;
};

export type UpdateTransactionInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Array<InputMaybe<AssetType>>>;
  authorizedUse?: InputMaybe<Scalars['String']['input']>;
  authorizedUses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  broker?: InputMaybe<Scalars['String']['input']>;
  buildableAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  buyer?: InputMaybe<Scalars['String']['input']>;
  buyerActivity?: InputMaybe<Scalars['String']['input']>;
  buyerNeq?: InputMaybe<Scalars['String']['input']>;
  buyerType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  codificationType?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  componentInscriptionNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  contamination?: InputMaybe<Scalars['String']['input']>;
  contaminationCost?: InputMaybe<Scalars['Float']['input']>;
  cptaq?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  dataRoomLink?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deductionComments?: InputMaybe<Scalars['String']['input']>;
  deductionFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deductionRatio?: InputMaybe<Scalars['Float']['input']>;
  density?: InputMaybe<Scalars['Int']['input']>;
  driveFolderId?: InputMaybe<Scalars['String']['input']>;
  endangeredSpecies?: InputMaybe<Scalars['Boolean']['input']>;
  fileBase64?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  floodableZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use isGrossLand instead. */
  grossLand?: InputMaybe<Scalars['Boolean']['input']>;
  infrastructure?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  infrastructureDeductionComments?: InputMaybe<Scalars['String']['input']>;
  infrastructureDeductionRatio?: InputMaybe<Scalars['Float']['input']>;
  inscriptionNumber: Scalars['String']['input'];
  isGrossLand?: InputMaybe<Scalars['Boolean']['input']>;
  landCategory?: InputMaybe<Scalars['String']['input']>;
  landCategoryNew?: InputMaybe<Array<InputMaybe<LandCategory>>>;
  landShape?: InputMaybe<Scalars['String']['input']>;
  landSubcategory?: InputMaybe<Array<InputMaybe<LandSubcategory>>>;
  landSubtype?: InputMaybe<Scalars['String']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lenderAmount?: InputMaybe<Scalars['Float']['input']>;
  marketplace?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  metadataBuildableAreaStatus?: InputMaybe<TransactionFieldStatus>;
  metadataBuyerDoneAt?: InputMaybe<Scalars['Date']['input']>;
  metadataBuyerStatus?: InputMaybe<Scalars['String']['input']>;
  metadataDoneAt?: InputMaybe<Scalars['Date']['input']>;
  metadataNumberOfUnitsStatus?: InputMaybe<TransactionFieldStatus>;
  metadataStatus?: InputMaybe<Scalars['String']['input']>;
  metadataStoriesStatus?: InputMaybe<TransactionFieldStatus>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  netLandAreaSqft?: InputMaybe<Scalars['Float']['input']>;
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  otherZoningDocumentLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  padLink?: InputMaybe<Scalars['String']['input']>;
  parcelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parcelReport?: InputMaybe<Scalars['String']['input']>;
  parkingIndoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingOutdoorCount?: InputMaybe<Scalars['Int']['input']>;
  parkingTypes?: InputMaybe<Array<TransactionParkingType>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  project3dModelLink?: InputMaybe<Scalars['String']['input']>;
  projectApproval?: InputMaybe<Scalars['String']['input']>;
  projectApprovalAtDeedOfSale?: InputMaybe<Scalars['String']['input']>;
  projectComments?: InputMaybe<Scalars['String']['input']>;
  projectDocument?: InputMaybe<Scalars['String']['input']>;
  projectLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  projectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  psaDate?: InputMaybe<Scalars['String']['input']>;
  saleContext?: InputMaybe<Scalars['String']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  salesBalance?: InputMaybe<Scalars['Boolean']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  sellerActivity?: InputMaybe<Scalars['String']['input']>;
  sellerNeq?: InputMaybe<Scalars['String']['input']>;
  sellerType?: InputMaybe<Scalars['String']['input']>;
  siteCoverageRatio?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tod?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  urbanPerimeter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Field no longer supported */
  urbanPlanLink?: InputMaybe<Scalars['String']['input']>;
  wetlands?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  zoningGridLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  zoningPlanLink?: InputMaybe<Scalars['String']['input']>;
};

export enum UrbanPlanType {
  OtherActive = 'OTHER_ACTIVE',
  OtherDraft = 'OTHER_DRAFT',
  PmadActive = 'PMAD_ACTIVE',
  PmadDraft = 'PMAD_DRAFT',
  PpuActive = 'PPU_ACTIVE',
  PpuDraft = 'PPU_DRAFT',
  PuActive = 'PU_ACTIVE',
  PuActiveInterview = 'PU_ACTIVE_INTERVIEW',
  PuDraft = 'PU_DRAFT',
  PuDraftInterview = 'PU_DRAFT_INTERVIEW',
  SadActive = 'SAD_ACTIVE',
  SadDraft = 'SAD_DRAFT'
}

export type UrbanPriority = {
  __typename?: 'UrbanPriority';
  planType: UrbanPlanType;
  priority: Scalars['Boolean']['output'];
};

export type UrbanPriorityInput = {
  planType: UrbanPlanType;
  priority: Scalars['Boolean']['input'];
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultPage?: Maybe<Page>;
  email: Scalars['String']['output'];
  extendedAccess?: Maybe<ExtendedAccess>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  projects: Array<Project>;
  roles: Array<UserRole>;
  unit?: Maybe<Unit>;
  updatedBy?: Maybe<User>;
};

export type UserRole = {
  __typename?: 'UserRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export enum UserRoleEnum {
  Analyst = 'analyst',
  Basic = 'basic',
  Broker = 'broker',
  Cca = 'cca',
  Coordinator = 'coordinator',
  Debugger = 'debugger',
  ExtendedAccess = 'extended_access',
  Prospector = 'prospector',
  SuperAdmin = 'super_admin'
}

export type ValidateIdTokenInput = {
  idToken: Scalars['String']['input'];
};

export type View = {
  __typename?: 'View';
  columnOverrides?: Maybe<Scalars['JSON']['output']>;
  filter?: Maybe<ViewFilter>;
  order: Array<ViewOrder>;
  scope: ViewScope;
  select?: Maybe<ViewSelect>;
};

export type ViewFilter = {
  __typename?: 'ViewFilter';
  buyer?: Maybe<BuyerViewFilter>;
  opportunity?: Maybe<OpportunityViewFilter>;
  parcel?: Maybe<ParcelViewFilter>;
  transaction?: Maybe<TransactionViewFilter>;
};

export type ViewFilterInput = {
  buyer?: InputMaybe<BuyerViewFilterInput>;
  opportunity?: InputMaybe<OpportunityViewFilterInput>;
  parcel?: InputMaybe<ParcelViewFilterInput>;
  transaction?: InputMaybe<TransactionViewFilterInput>;
};

export type ViewInput = {
  /** Table column visibility and grouping, keyed by column id. */
  columnOverrides?: InputMaybe<Scalars['JSON']['input']>;
  filter?: InputMaybe<ViewFilterInput>;
  order?: InputMaybe<Array<ViewOrderInput>>;
  scope: ViewScope;
  select?: InputMaybe<ViewSelectInput>;
};

export type ViewOrder = {
  __typename?: 'ViewOrder';
  direction?: Maybe<SortOrder>;
  field: Scalars['String']['output'];
};

export type ViewOrderInput = {
  direction?: InputMaybe<SortOrder>;
  field: Scalars['String']['input'];
};

export enum ViewScope {
  BuyersTable = 'BUYERS_TABLE',
  OpportunitiesHuntingMap = 'OPPORTUNITIES_HUNTING_MAP',
  OpportunitiesHuntingTable = 'OPPORTUNITIES_HUNTING_TABLE',
  OpportunitiesMap = 'OPPORTUNITIES_MAP',
  OpportunitiesTable = 'OPPORTUNITIES_TABLE',
  ParcelsHuntingMap = 'PARCELS_HUNTING_MAP',
  ParcelsMap = 'PARCELS_MAP',
  TransactionsHuntingMap = 'TRANSACTIONS_HUNTING_MAP',
  TransactionsMap = 'TRANSACTIONS_MAP',
  TransactionsTable = 'TRANSACTIONS_TABLE'
}

export type ViewSelect = {
  __typename?: 'ViewSelect';
  buyer?: Maybe<Array<BuyerField>>;
  opportunity?: Maybe<Array<OpportunityField>>;
  parcel?: Maybe<Array<ParcelField>>;
  transaction?: Maybe<Array<TransactionField>>;
};

export type ViewSelectInput = {
  buyer?: InputMaybe<Array<BuyerField>>;
  opportunity?: InputMaybe<Array<OpportunityField>>;
  parcel?: InputMaybe<Array<ParcelField>>;
  transaction?: InputMaybe<Array<TransactionField>>;
};

/** A municipal zone covering a parcel, with the rules of its zoning grid */
export type Zone = {
  __typename?: 'Zone';
  borough?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  documentUrl?: Maybe<Scalars['String']['output']>;
  gridUrl?: Maybe<Scalars['String']['output']>;
  rules: Array<ZoningRule>;
  zoneCode: Scalars['String']['output'];
};

/** One row of a zoning grid: a permitted use and its buildable envelope */
export type ZoningRule = {
  __typename?: 'ZoningRule';
  bylawNumber?: Maybe<Scalars['String']['output']>;
  excludedUseCodes?: Maybe<Scalars['String']['output']>;
  isPrincipalUse?: Maybe<Scalars['Boolean']['output']>;
  maxBuildingWidthMeters?: Maybe<Scalars['Float']['output']>;
  maxCoverageRatio?: Maybe<Scalars['Float']['output']>;
  maxFloorAreaRatio?: Maybe<Scalars['Float']['output']>;
  maxFloorAreaSquareMeters?: Maybe<Scalars['Float']['output']>;
  maxFootprintSquareMeters?: Maybe<Scalars['Float']['output']>;
  maxFrontSetbackMeters?: Maybe<Scalars['Float']['output']>;
  maxHeightFloors?: Maybe<Scalars['Float']['output']>;
  maxHeightMeters?: Maybe<Scalars['Float']['output']>;
  maxNetDensity?: Maybe<Scalars['Float']['output']>;
  maxSideStreetSetbackMeters?: Maybe<Scalars['Float']['output']>;
  maxUnitsPerBuilding?: Maybe<Scalars['Float']['output']>;
  minBuildingWidthMeters?: Maybe<Scalars['Float']['output']>;
  minCoverageRatio?: Maybe<Scalars['Float']['output']>;
  minFloorAreaRatio?: Maybe<Scalars['Float']['output']>;
  minFloorAreaSquareMeters?: Maybe<Scalars['Float']['output']>;
  minFootprintSquareMeters?: Maybe<Scalars['Float']['output']>;
  minFrontSetbackMeters?: Maybe<Scalars['Float']['output']>;
  minHeightFloors?: Maybe<Scalars['Float']['output']>;
  minHeightMeters?: Maybe<Scalars['Float']['output']>;
  minLotAreaSquareMeters?: Maybe<Scalars['Float']['output']>;
  minLotDepthMeters?: Maybe<Scalars['Float']['output']>;
  minLotWidthMeters?: Maybe<Scalars['Float']['output']>;
  minNetDensity?: Maybe<Scalars['Float']['output']>;
  minSideStreetSetbackMeters?: Maybe<Scalars['Float']['output']>;
  minUnitsPerBuilding?: Maybe<Scalars['Float']['output']>;
  otherProvisionCodes?: Maybe<Scalars['String']['output']>;
  permittedUseCodes?: Maybe<Scalars['String']['output']>;
  printDate?: Maybe<Scalars['String']['output']>;
  rearSetbackMeters?: Maybe<Scalars['Float']['output']>;
  sideSetbackMeters?: Maybe<Scalars['Float']['output']>;
  specialProvisionCodes?: Maybe<Scalars['String']['output']>;
  structureType?: Maybe<Scalars['String']['output']>;
  totalSideSetbackMeters?: Maybe<Scalars['Float']['output']>;
  useClass?: Maybe<Scalars['String']['output']>;
  useClassDescription?: Maybe<Scalars['String']['output']>;
  useGroup?: Maybe<Scalars['String']['output']>;
};
